
import genia from './img/partners/genia.png'
import imv from './img/partners/imv.png'
import spermex from './img/partners/spermex.png'
import lactalis from './img/partners/lactalis.png'
import coopex from './img/partners/Coopex.png'
import obione from './img/partners/Obione.png'
import synetics from './img/partners/synetics.png'
import aberekin from './img/partners/aberekin.png'

export const banner = [
    {
        srcSP: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717420263/Banners/holstein_sxiywn.webp",
        title: "Holstein: Excellence et Héritage Laitier",
        promotion: false,
        subtitle: "Semence animale congelée de la race Holstein",
        description: "Plongez dans l'univers de la race Holstein, réputée pour sa qualité laitière inégalée. Nos taureaux Holstein vous offrent l'excellence génétique nécessaire pour optimiser la production laitière et assurer la rentabilité de votre élevage.",
        specification: '',
        in_stock: true,
        promotionOffer: "",

    },
    {
        srcSP: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717420583/Banners/montb%C3%A9liarde_yajxo4.webp",
        title: "Montbéliarde: Qualité et Génétique Éprouvées",
        promotion: false,
        subtitle: "Semence animale congelée de la race Montbéliarde",
        description: "Découvrez notre gamme de semences Montbéliarde, symbole de robustesse et de performance. Des géniteurs qui transmettent leur puissance à chaque génération, garantissant des troupeaux solides et prospères.",
        specification: '',
        in_stock: true,
        promotionOffer: "",
    },
    {
        srcSP: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717420584/Banners/swiss_uxqyeg.webp",
        title: "Brown Swiss: Tradition et Fiabilité",
        promotion: false,
        subtitle: "Semence animale congelée de la race Brown Swiss",
        description: "Explorez notre sélection de semences Brown Swiss, un héritage de tradition et de fiabilité. Ces taureaux, reconnus pour leur rusticité et leur adaptabilité, sont les partenaires idéaux pour garantir le succès de votre élevage.",
        specification: '',
        in_stock: true,
        promotionOffer: "",
    },
    {
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719315179/Banners/Andaman_nzlcth.webp",
        "title": "Andaman : Production et Longévité",
        "promotion": false,
        "subtitle": "Semence animale congelée de la race Brown Swiss",
        "description": "Andaman est un taureau exceptionnel de la race Brown Swiss qui combine une production élevée et des traits fonctionnels solides, rendant son héritage précieux pour toute exploitation laitière. Andaman se distingue par ses excellentes caractéristiques génétiques, particulièrement dans le domaine de la production laitière. Avec un index global (GZW) de 134, il excelle dans la plupart des critères importants pour les éleveurs.",
        "specification": "[{\" Caractéristique\":\"GZW\",\"Valeur (Index)\":\"134\",\"Analyse\":\"Très bonne note globale, indiquant des caractéristiques génétiques très favorables.\"},{\" Caractéristique\":\"Index lait (MW)\",\"Valeur (Index)\":\"119\",\"Analyse\":\"Très bon indice, montrant une forte capacité de production laitière.\"},{\" Caractéristique\":\"Lait\",\"Valeur (Index)\":\"+797 kg\",\"Analyse\":\"Augmentation significative de la production laitière par rapport à la moyenne.\"},{\" Caractéristique\":\"Protéines\",\"Valeur (Index)\":\"-0.06 % (+23 kg)\",\"Analyse\":\"Légère diminution en pourcentage, mais augmentation notable en kg, favorable pour la production.\"},{\" Caractéristique\":\"Matières grasses\",\"Valeur (Index)\":\"-0.01 % (+33 kg)\",\"Analyse\":\"Légère diminution en pourcentage, mais augmentation en kg, ce qui est positif pour la production.\"},{\" Caractéristique\":\"Valeur bouchère\",\"Valeur (Index)\":\"98\",\"Analyse\":\"Note moyenne, indiquant une qualité de viande correcte.\"},{\" Caractéristique\":\"FIT (Fonctionnalité)\",\"Valeur (Index)\":\"113\",\"Analyse\":\"Excellente note, montrant de très bonnes caractéristiques fonctionnelles.\"},{\" Caractéristique\":\"Longévité\",\"Valeur (Index)\":\"105\",\"Analyse\":\"Indique que les filles de ce taureau vivent plus longtemps que la moyenne.\"},{\" Caractéristique\":\"Santé mamelle\",\"Valeur (Index)\":\"104\",\"Analyse\":\"Bonne santé de la mamelle, réduisant les risques de maladies comme la mammite.\"},{\" Caractéristique\":\"Facilité de naissance\",\"Valeur (Index)\":\"101\",\"Analyse\":\"Note moyenne, montrant que ce taureau ne pose pas de problèmes particuliers pour la naissance des veaux.\"},{\" Caractéristique\":\"Facilité de vêlage\",\"Valeur (Index)\":\"103\",\"Analyse\":\"Bonne facilité de vêlage, réduisant les risques de complications lors du vêlage.\"},{\" Caractéristique\":\"Persistance\",\"Valeur (Index)\":\"114\",\"Analyse\":\"Excellente persistance de la production laitière tout au long de la lactation.\"},{\" Caractéristique\":\"Cellules somatiques\",\"Valeur (Index)\":\"101\",\"Analyse\":\"Bon niveau de santé, un faible nombre de cellules somatiques est souhaitable.\"},{\" Caractéristique\":\"Fertilité maternelle\",\"Valeur (Index)\":\"111\",\"Analyse\":\"Très bonne fertilité des filles de ce taureau.\"},{\" Caractéristique\":\"Vitesse de traite\",\"Valeur (Index)\":\"87\",\"Analyse\":\"Vitesse de traite plus lente que la moyenne, peut être un inconvénient selon les priorités de l'exploitation.\"},{\" Caractéristique\":\"Comportement de traite\",\"Valeur (Index)\":\"109\",\"Analyse\":\"Bon comportement de traite, essentiel pour une gestion efficace de l'exploitation.\"},{\" Caractéristique\":\"Santé des sabots\",\"Valeur (Index)\":\"92\",\"Analyse\":\"Légèrement en dessous de la moyenne, possible attention nécessaire pour les sabots.\"}]",
        "in_stock": true,
        "promotionOffer": "",
    },
    {
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719321435/Banners/Hallodri_ghdqxo.webp",
        "title": "Hallodri: qualité et robustesse",
        "promotion": false,
        "subtitle": "Semence animale congelée de la race Brown Swiss",
        "description": "Hallodri se distingue par ses excellentes performances globales, avec un GZW de 126, témoignant de sa supériorité en production laitière et en qualité de viande. Ses filles produisent en moyenne 1034 kg de lait supplémentaires, avec des gains significatifs en matière grasse et en protéines, ce qui est idéal pour les éleveurs laitiers. De plus, Hallodri offre une bonne longévité et une santé mammaire exceptionnelle, garantissant des vaches robustes et productives sur le long terme. Il a des indices élevés pour la valeur bouchère (FW 108) et le gain net (108), ainsi qu'une bonne note pour la carcasse (106) et la classe marchande (100). Ces indices suggèrent qu'Hallodri produit des veaux mâles de bon gabarit avec un poids acceptable à la naissance et un rythme de croissance rapide. Sa bonne musculature et ses talons épais contribuent à des veaux solides et bien conformés. En choisissant Hallodri, vous investissez dans un taureau qui combine qualité, performance et robustesse.",
        "specification": "[{\" Caractéristique\":\"GZW\",\"Valeur (Index)\":\"126\",\"Analyse\":\"Très bonne note globale, indiquant des caractéristiques génétiques très favorables.\"},{\" Caractéristique\":\"Index lait (MW)\",\"Valeur (Index)\":\"113\",\"Analyse\":\"Bon indice, montrant une forte capacité de production laitière.\"},{\" Caractéristique\":\"Lait\",\"Valeur (Index)\":\"+1034 kg\",\"Analyse\":\"Augmentation significative de la production laitière par rapport à la moyenne.\"},{\" Caractéristique\":\"Protéines\",\"Valeur (Index)\":\"-0.13% (+26 kg)\",\"Analyse\":\"Légère diminution en pourcentage, mais augmentation notable en kg, favorable pour la production.\"},{\" Caractéristique\":\"Matières grasses\",\"Valeur (Index)\":\"-0.37 % (+11 kg)\",\"Analyse\":\"Légère diminution en pourcentage, mais augmentation en kg, ce qui est positif pour la production.\"},{\" Caractéristique\":\"Valeur bouchère\",\"Valeur (Index)\":\"115\",\"Analyse\":\"Bonne qualité de la viande des veaux issus de ce taureau\"},{\" Caractéristique\":\"FIT (Fonctionnalité)\",\"Valeur (Index)\":\"109\",\"Analyse\":\"Bonne note, montrant de bonnes caractéristiques fonctionnelles.\"},{\" Caractéristique\":\"Longévité\",\"Valeur (Index)\":\"102\",\"Analyse\":\"Les filles de ce taureau vivent un peu plus longtemps que la moyenne.\"},{\" Caractéristique\":\"Santé mamelle\",\"Valeur (Index)\":\"102\",\"Analyse\":\"Bonne santé de la mamelle, réduisant les risques de maladies comme la mammite.\"},{\" Caractéristique\":\"Facilité de naissance\",\"Valeur (Index)\":\"103\",\"Analyse\":\"Note moyenne, montrant que ce taureau ne pose pas de problèmes particuliers pour la naissance des veaux.\"},{\" Caractéristique\":\"Facilité de vêlage\",\"Valeur (Index)\":\"99\",\"Analyse\":\"Note moyenne, réduisant les risques de complications lors du vêlage.\"},{\" Caractéristique\":\"Persistance\",\"Valeur (Index)\":\"111\",\"Analyse\":\"Excellente persistance de la production laitière tout au long de la lactation.\"},{\" Caractéristique\":\"Cellules somatiques\",\"Valeur (Index)\":\"104\",\"Analyse\":\"Bon niveau de santé, un faible nombre de cellules somatiques est souhaitable.\"},{\" Caractéristique\":\"Fertilité maternelle\",\"Valeur (Index)\":\"107\",\"Analyse\":\"Bonne fertilité des filles de ce taureau.\"},{\" Caractéristique\":\"Vitesse de traite\",\"Valeur (Index)\":\"109\",\"Analyse\":\"Vitesse de traite rapide, peut être un avantage selon les priorités de l'exploitation.\"},{\" Caractéristique\":\"Comportement de traite\",\"Valeur (Index)\":\"97\",\"Analyse\":\"Note moyenne. Le comportement pourrait être meilleur lors de la traite\"},{\" Caractéristique\":\"Santé des sabots\",\"Valeur (Index)\":\"92\",\"Analyse\":\"Légèrement en dessous de la moyenne, possible attention nécessaire pour les sabots.\"}]",
        "in_stock": true,
        "promotionOffer": ""
    },
    {
        srcSP: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719324408/Banners/Vassri_eb6aho.webp",
        title: "Vassri: production laitière exceptionnelle",
        promotion: false,
        subtitle: "Semence animale congelée de la race Brown Swiss",
        description: "Vassri est un choix exceptionnel pour tout éleveur cherchant à améliorer son troupeau. Avec un GZW de 134, il se distingue par une production laitière impressionnante, ajoutant en moyenne 925 kg de lait par lactation, ainsi qu'une excellente santé mammaire et une persistance de production remarquable. Ses filles, dotées de variantes génétiques recherchées comme la Kappa Caséine BB et la Bêta Caséine A2A2, présentent une vitalité et une fertilité accrues, garantissant des vaches robustes et productives. De plus, Vassri affiche un excellent comportement à la traite et une bonne fonctionnalité générale, faisant de lui un investissement judicieux pour maximiser la rentabilité et la qualité de l'élevage.",
        specification: "[{\" Caractéristique\":\"GZW\",\"Valeur (Index)\":\"134\",\"Analyse\":\"Un GZW très élevé indique que Vassri a des performances globales exceptionnelles.\"},{\" Caractéristique\":\"Index lait (MW)\",\"Valeur (Index)\":\"121\",\"Analyse\":\"Très Bon indice, montrant que les filles de Vassri produisent beaucoup plus de lait que la moyenne.\"},{\" Caractéristique\":\"Lait\",\"Valeur (Index)\":\"+925 kg\",\"Analyse\":\"Augmentation significative de la production laitière par rapport à la moyenne.\"},{\" Caractéristique\":\"Protéines\",\"Valeur (Index)\":\"-0.10% (+24 kg)\",\"Analyse\":\"Légère diminution en pourcentage, mais augmentation notable en kg, favorable pour la production.\"},{\" Caractéristique\":\"Matières grasses\",\"Valeur (Index)\":\"+0.04 % (+42 kg)\",\"Analyse\":\"Augmentation notable en termes de quantité de matière grasse.\"},{\" Caractéristique\":\"Valeur bouchère\",\"Valeur (Index)\":\"101\",\"Analyse\":\"Qualité acceptable de la viande des veaux issus de ce taureau.\"},{\" Caractéristique\":\"FIT (Fonctionnalité)\",\"Valeur (Index)\":\"108\",\"Analyse\":\"Bonne note, montrant de bonnes caractéristiques fonctionnelles.\"},{\" Caractéristique\":\"Longévité\",\"Valeur (Index)\":\"102\",\"Analyse\":\"Les filles de ce taureau vivent un peu plus longtemps que la moyenne.\"},{\" Caractéristique\":\"Santé mamelle\",\"Valeur (Index)\":\"105\",\"Analyse\":\"Excellente santé des mamelles.\"},{\" Caractéristique\":\"Facilité de naissance\",\"Valeur (Index)\":\"104\",\"Analyse\":\"Pas de problèmes particuliers pour la naissance des veaux.\"},{\" Caractéristique\":\"Facilité de vêlage\",\"Valeur (Index)\":\"102\",\"Analyse\":\"Note moyenne, réduisant les risques de complications lors du vêlage.\"},{\" Caractéristique\":\"Persistance\",\"Valeur (Index)\":\"111\",\"Analyse\":\"Excellente persistance de la production laitière tout au long de la lactation.\"},{\" Caractéristique\":\"Cellules somatiques\",\"Valeur (Index)\":\"108\",\"Analyse\":\"Bon niveau de santé des mamelles, un faible nombre de cellules somatiques est souhaitable.\"},{\" Caractéristique\":\"Fertilité maternelle\",\"Valeur (Index)\":\"103\",\"Analyse\":\"Bonne fertilité des filles de ce taureau.\"},{\" Caractéristique\":\"Vitesse de traite\",\"Valeur (Index)\":\"108\",\"Analyse\":\"Vitesse de traite rapide, peut être un avantage selon les priorités de l'exploitation.\"},{\" Caractéristique\":\"Comportement de traite\",\"Valeur (Index)\":\"117\",\"Analyse\":\"Très bon comportement lors de la traite\"},{\" Caractéristique\":\"Santé des sabots\",\"Valeur (Index)\":\"101\",\"Analyse\":\"Bonne santé des sabots.\"}]",
        in_stock: true,
        promotionOffer: ""
    },
    {
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719327778/Banners/Sepp_Pp_sa5pde.webp",
        "title": "Sepp: Des générations sans cornes",
        "promotion": false,
        "subtitle": "Semence animale congelée de la race Brown Swiss",
        "description": "Sepp *Pp est un atout précieux pour tout éleveur souhaitant optimiser son troupeau avec des descendants sans cornes. Avec un GZW de 138, il garantit des performances exceptionnelles, notamment une production laitière accrue de 1004 kg, une excellente santé mammaire et une longévité supérieure. Ses filles, robustes et productives, présentent également des avantages génétiques recherchés pour la transformation fromagère. En choisissant Sepp *Pp, vous investissez dans un taureau qui combine rendement laitier, santé et durabilité, tout en assurant une amélioration significative de la qualité et de la rentabilité de l'élevage grâce à la transmission probable du gène sans cornes à sa descendance.",
        "specification": "[{\" Caractéristique\":\"GZW\",\"Valeur (Index)\":\"138\",\"Analyse\":\"Un GZW très élevé qui témoigne de performances globales exceptionnelles\"},{\" Caractéristique\":\"Index lait (MW)\",\"Valeur (Index)\":\"122\",\"Analyse\":\"Très Bon indice, montrant que les filles de Vassri produisent beaucoup plus de lait que la moyenne.\"},{\" Caractéristique\":\"Lait\",\"Valeur (Index)\":\"+1004 kg\",\"Analyse\":\"Augmentation significative de la production laitière par rapport à la moyenne.\"},{\" Caractéristique\":\"Protéines\",\"Valeur (Index)\":\"-0.08% (+29 kg)\",\"Analyse\":\"Légère diminution en pourcentage, mais augmentation notable en kg, favorable pour la production.\"},{\" Caractéristique\":\"Matières grasses\",\"Valeur (Index)\":\"-0.09 % (+34 kg)\",\"Analyse\":\"Augmentation notable en termes de quantité de matière grasse.\"},{\" Caractéristique\":\"Valeur bouchère\",\"Valeur (Index)\":\"101\",\"Analyse\":\"Qualité acceptable de la viande des veaux issus de ce taureau.\"},{\" Caractéristique\":\"FIT (Fonctionnalité)\",\"Valeur (Index)\":\"118\",\"Analyse\":\"Très bonne note, montrant de très bonnes caractéristiques fonctionnelles.\"},{\" Caractéristique\":\"Longévité\",\"Valeur (Index)\":\"117\",\"Analyse\":\"Les filles de ce taureau vivent plus longtemps que la moyenne.\"},{\" Caractéristique\":\"Santé mamelle\",\"Valeur (Index)\":\"108\",\"Analyse\":\"Excellente santé des mamelles.\"},{\" Caractéristique\":\"Facilité de naissance\",\"Valeur (Index)\":\"113\",\"Analyse\":\"Pas de problèmes particuliers pour la naissance des veaux.\"},{\" Caractéristique\":\"Facilité de vêlage\",\"Valeur (Index)\":\"98\",\"Analyse\":\"Note moyenne, réduisant les risques de complications lors du vêlage.\"},{\" Caractéristique\":\"Persistance\",\"Valeur (Index)\":\"111\",\"Analyse\":\"Excellente persistance de la production laitière tout au long de la lactation.\"},{\" Caractéristique\":\"Cellules somatiques\",\"Valeur (Index)\":\"110\",\"Analyse\":\"Bonne santé des mamelles avec peu d'infections.\"},{\" Caractéristique\":\"Fertilité maternelle\",\"Valeur (Index)\":\"111\",\"Analyse\":\"Très bonne fertilité des filles de ce taureau.\"},{\" Caractéristique\":\"Vitesse de traite\",\"Valeur (Index)\":\"99\",\"Analyse\":\"Vitesse de traite correcte.\"},{\" Caractéristique\":\"Comportement de traite\",\"Valeur (Index)\":\"106\",\"Analyse\":\"Bon comportement lors de la traite\"},{\" Caractéristique\":\"Santé des sabots\",\"Valeur (Index)\":\"100\",\"Analyse\":\"Bonne santé des sabots.\"}]",
        "in_stock": true,
        "promotionOffer": ""
    }
]

export const products = [
    {
        src: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717423164/Products/seringues-hypodermiques2_phetbr.webp",
        category: "Injection",
        target: "Chat/chien",
        title: "Seringue hypodermique",
        promotion: false,
        topSale: false,
        newProduct: false,
        srcSP: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717423163/Products/seringues-hypodermiques_gbjgh3.webp",
        subtitle: "Seringues hypodermiques en plexiglas pour professionnels.",
        description: "Plexiglas tourné dans la masse et traité pour éviter les déformations et les craquelures. Pistons, axes, béquilles en acier inoxydable et chapeaux en zamac chromé. Joints plats en silicone, biseautés, très résistants, hydrophobes, anti-adhérents, assurant une étanchéité parfaite et un glissement léger du piston. Stérilisation : résistantes à l'ébullition et à l'autoclave jusqu'à 125°C (30 min - 1,3 bars), mais pas à l'alcool. Sans contre-indication avec les produits pharmaceutiques courants. Entièrement démontables. Marquage des graduations indélébiles et de couleur noire. Embase Luer-Lock bibloc en laiton nickelé.",
        specification: "[{\"Modèle\":\"Standard\",\"Capacité\":\"2 mL\",\"Graduation\":\"0,1mL\",\"Embase\":\"Centrée\"},{\"Modèle\":\"Standard\",\"Capacité\":\"3 mL\",\"Graduation\":\"0,1 mL\",\"Embase\":\"Centrée\"},{\"Modèle\":\"Standard\",\"Capacité\":\"10 mL\",\"Graduation\":\"0,5 mL\",\"Embase\":\"Centrée\"},{\"Modèle\":\"Standard\",\"Capacité\":\"20 mL\",\"Graduation\":\"1 mL\",\"Embase\":\"Excentrée\"}]",
        in_stock: true,
        promotionOffer: "",
        filter: "seringues"
    },
    {
        src: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717427244/Products/Vit_Min_twlvnz.webp",
        category: "COMP ALIMENTAIRE",
        target: "Chat/chien",
        title: "Vit&Min",
        promotion: false,
        topSale: false,
        newProduct: false,
        srcSP: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717427246/Products/Vit_Min1_xhu88a.webp",
        subtitle: "Complément alimentaire vitaminique pour chien et chat.",
        description: "Vit&Min de Vetexpert est un supplément en vitamines et en minéraux pour chiens et chats. Le complément alimentaire Vit&Min peut être utilisé pour compléter les rations ménagères déficitaires en vitamines et en minéraux. Il permet aussi de renforcer l'apport en vitamines et en minéraux chez les animaux présentant des besoins accrus : pendant la croissance chez les femelles en gestation ou en lactation, chez les chiens âgés, pendant la convalescence de troubles ayant conduit à une baisse d'appétit importante, lors de malabsorption, malassimilation ou d'accélération du transit, lors d'activités physiques importantes (chasse, sport, travail).",
        specification: '',
        in_stock: true,
        promotionOffer: "",
        filter: "compléments alimentaires canine"
    },
    {
        src: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717427564/Products/Tire-tiques_yxtfvl.webp",
        category: "Divers",
        target: "Chat/chien",
        title: "Tire tiques",
        promotion: false,
        topSale: false,
        newProduct: false,

        srcSP: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717427563/Products/Tire-tiques1_uf0rgz.webp",
        subtitle: "Tire-tiques permettant de retirer les tiques sur les animaux en toute sécurité, de manière rapide et efficace !",
        description: "Le Tiker® est pratique, grâce à ses deux tailles de cuillères placées têtebêche, qui permettent de retirer les parasites de toutes tailles avec un unique instrument. Fabriqué en Green PE, le TIKER® est: Rapide, Sans douleur,  Hygiénique, Ne laisse pas le rostre (tête) de la tique sous la peau, La cuillère permet de retenir la tique le temps de l'éliminer.",
        specification: '',
        in_stock: true,
        promotionOffer: "",
        filter: "divers canine"
    },
    {
        src: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717428872/Products/Colliers_carcans1_rdjsk6.webp",
        category: "Divers",
        target: "Chat/chien",
        title: "VELFAST®",
        promotion: false,
        topSale: false,
        newProduct: false,

        srcSP: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717428873/Products/Colliers_carcans_avpdbr.webp",
        subtitle: "Colliers carcans en polypropylène transparent incolore avec double liseré néoprène.",
        description: "Liseré néoprène périphérique souple et silencieux, amortissant les chocs et le bruit. Il permet un meilleur confort pour l'animal et une adaptation plus rapide au port du carcan. Liseré néoprène atraumatique autour du cou. Fixation simple et rapide par scratch offrant une excellente résistance à l'arrachage. Réglage de la bande scratch autour du cou. Lignes anti-rayures en relief. Solidité renforcée grâce au liseré. Code couleur pour identifier les tailles.",
        specification: "[{\"Taille\":\"7,5 cm\",\"Couleur\":\"Bleu clair\",\"Tour de cou min\":\"14 cm\",\"Tour de cou max\":\"17 cm\"},{\"Taille\":\"10 cm\",\"Couleur\":\"Violet\",\"Tour de cou min\":\"18 cm\",\"Tour de cou max\":\"23 cm\"},{\"Taille\":\"12,5 cm\",\"Couleur\":\"Orange\",\"Tour de cou min\":\"24 cm\",\"Tour de cou max\":\"29 cm\"},{\"Taille\":\"15 cm\",\"Couleur\":\"Vert\",\"Tour de cou min\":\"30 cm\",\"Tour de cou max\":\"36 cm\"},{\"Taille\":\"20 cm\",\"Couleur\":\"Jaune\",\"Tour de cou min\":\"37 cm\",\"Tour de cou max\":\"43 cm\"},{\"Taille\":\"25 cm\",\"Couleur\":\"Rouge\",\"Tour de cou min\":\"44 cm\",\"Tour de cou max\":\"50 cm\"},{\"Taille\":\"30 cm\",\"Couleur\":\"Bleu\",\"Tour de cou min\":\"51 cm\",\"Tour de cou max\":\"58 cm\"}]",
        in_stock: true,
        promotionOffer: "",
        filter: "contention canine"
    },
    {
        src: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717429329/Products/seringue_%C3%A0_usage_unique1_yn8jaq.webp",
        category: "Injection",
        target: "Usages divers",
        title: "Seringue à usage unique",
        promotion: false,
        topSale: false,
        newProduct: false,

        srcSP: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717429328/Products/seringue_%C3%A0_usage_unique_pr2twz.webp",
        subtitle: "SERINGUE 1ML ,2ML/3ML, 5ML, 10ML, 20ML, 50ML",
        description: "Seringues à usage unique, stériles et apyrogènes en conformité avec les normes internationales. Etanchéité absolue, échelle de graduation très lisible, dosage précis, stérilisation à l'oxyde d'éthylène.",
        specification: "",
        in_stock: true,
        promotionOffer: "",
        filter: "seringues"
    },
    {
        src: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717429745/Products/Aiguille_SOFAP1_wbkjsv.webp",
        category: "Injection",
        target: "Usages divers",
        title: "Aiguille à usage unique",
        promotion: false,
        topSale: false,
        newProduct: false,

        srcSP: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717429744/Products/Aiguille_SOFAP_kcz5cg.webp",
        subtitle: "Aiguilles Hypodermiques",
        description: "Aiguille en acier inox AISI304, fabriquée et contrôlée selon des méthodes technologiques avancées pour une injection sans douleur.",
        specification: "[{\"Calibre\":\"18G\",\"Épaisseur\":\"1.25 mm\",\"Couleur\":\"Rose\"},{\"Calibre\":\"19G\",\"Épaisseur\":\"1.05 mm\",\"Couleur\":\"Crème\"},{\"Calibre\":\"20G\",\"Épaisseur\":\"0.9 mm\",\"Couleur\":\"Jaune\"},{\"Calibre\":\"21G\",\"Épaisseur\":\"0.8 mm\",\"Couleur\":\"Verte\"},{\"Calibre\":\"22G\",\"Épaisseur\":\"0.7 mm\",\"Couleur\":\"Noire\"},{\"Calibre\":\"23G\",\"Épaisseur\":\"0.65 mm\",\"Couleur\":\"Bleu\"},{\"Calibre\":\"25G\",\"Épaisseur\":\"0.5 mm\",\"Couleur\":\"Orange\"},{\"Calibre\":\"26G\",\"Épaisseur\":\"0.45 mm\",\"Couleur\":\"Marron\"},{\"Calibre\":\"27G\",\"Épaisseur\":\"0.4 mm\",\"Couleur\":\"Gris\"},{\"Calibre\":\"30G\",\"Épaisseur\":\"0.29 mm\",\"Couleur\":\"Jaune\"}]",
        in_stock: true,
        promotionOffer: "",
        filter: "aiguilles"
    },
    {
        src: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717488186/Products/Gants_Nitrile1_ata576.webp",
        category: "Divers",
        target: "Usages divers",
        title: "Gants Nitrile",
        promotion: false,
        topSale: false,
        newProduct: false,
        srcSP: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717488186/Products/Gants_Nitrile_mi6mzr.webp",
        subtitle: "Gants de protection contre les risques chimiques",
        description: "Les gants en nitrile apportent une protection accrue. Ils sont très résistants contre les virus, bactéries, micro-organismes et risques chimiques. L'extrémité des doigts texturée avec des micro-rugosités améliore la préhension. L'épaisseur optimisée et la matière souple sont idéales pour les soins médicaux demandant précision et dextérité. Gants jetables recommandés dans le secteur médical pour les examens médicaux, en laboratoire (résistants aux virus) et en industrie. Gants sans latex et non poudrés, conformes aux nouvelles préconisations lors des manipulations médicales. Recommandés pour les personnes allergiques au latex ou sensibles aux gants poudrés.",
        specification: '',
        in_stock: true,
        promotionOffer: "",
        filter: "protection canine"
    },
    {
        src: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717488654/Products/Gaine_ins%C3%A9mination1_wpbysw.webp",
        category: "Insémination",
        target: "Bovins",
        title: "Gaine d'insémination",
        promotion: false,
        topSale: false,
        newProduct: false,
        srcSP: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717488654/Products/Gaine_ins%C3%A9mination_mbntmp.webp",
        subtitle: "Gaine d'insémination universelle (Minitube)",
        description: "Gaine IA transparente bleue, adaptée à tous types de paillettes de semence, y compris les formats 0,5 ml et 0,25 ml. Conditionnée en sachets refermables de 50 pièces, elle assure un ajustement parfaitement hermétique avec toutes les paillettes. La forme de l'embout permet une insémination en douceur, tandis que la transparence de la gaine offre un meilleur contrôle visuel de la position de la paillette. Les sachets sont munis d'un ruban adhésif pour une fermeture et une réouverture faciles.",
        specification: "",
        in_stock: true,
        promotionOffer: "",
        filter: "reproduction elevage"
    },
    {
        src: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717757205/Products/AIGUILLE_%C3%80_PR%C3%89L%C3%88VEMENT_MULTIPLE_buby0p.webp",
        category: "Prélèvements",
        target: "Usages divers",
        title: "Aiguilles VENOJECT G21",
        promotion: false,
        topSale: false,
        newProduct: false,
        srcSP: "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717757205/Products/AIGUILLE_%C3%80_PR%C3%89L%C3%88VEMENT_MULTIPLE1_qr4p36.webp",
        subtitle: "AIGUILLE À PRÉLÈVEMENT MULTIPLE G21",
        description: "Aiguilles standard avec fixation à vis mesurent 28 mm de longueur et 0,8 mm de diamètre, avec un code couleur vert. Elles sont dotées d'un concept unique de triple biseau qui pénètre le tissu avec une incision minimisant le traumatisme. Équipées d'un manchon, elles réduisent le risque de contamination en obturant l'orifice distal de l'aiguille à chaque changement de tube. Leur paroi ultra-mince permet un débit sanguin accru grâce à un diamètre interne plus grand. Conditionnées dans un étui rigide tubulaire, elles sont munies d'une étiquette d'inviolabilité avec numéro de lot et date de péremption. Fiables et confortables, elles sont disponibles en boîte de 100 aiguilles.",
        specification: "",
        in_stock: true,
        promotionOffer: "",
        filter: "aiguilles"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717763023/Products/Branule_eyzsdy.webp",
        "category": "Injection",
        "target": "Usages divers",
        "title": "Branule",
        "promotion": false,
        "topSale": false,
        "newProduct": true,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717763024/Products/Branule1_lulzhi.webp",
        "subtitle": "Branules souples en polyuréthane",
        "description": "Les branules souples en polyuréthane ou polyuréthane siliconé sont introduites dans une veine périphérique à l'aide d'un mandrin aiguille. Utilisées pour l'administration intraveineuse et intermittente de médicaments, elles possèdent un capuchon coloré spécialement conçu pour éviter toute contamination lorsque la valve n'est pas utilisée. Les aiguilles sont équipées d'une valve d'injection colorée selon le code international, correspondant à la taille de l'aiguille, et d'ailettes latérales qui permettent une administration de médicaments sans douleur.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "aiguilles"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717764972/Products/perfuseur_c44wvy.webp",
        "category": "Injection",
        "target": "Usages divers",
        "title": "Perfuseur",
        "promotion": false,
        "topSale": true,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717764973/Products/perfuseur1_icbm39.webp",
        "subtitle": "Perfuseur par gravité",
        "description": "Un perfuseur par gravité est un dispositif médical utilisé pour administrer des produits injectables, généralement des médicaments, d'une poche de perfusion vers un patient, souvent alité. Il permet de délivrer le liquide dans le sang par voie intraveineuse ou autre voie parentérale, comme pour la nutrition. Une voie parentérale correspond à une méthode d'administration autre que par le tube digestif.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "aiguilles"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717765961/Products/Epicr%C3%A2nienne_dxwjrb.webp",
        "category": "Injection",
        "target": "Usages divers",
        "title": "Aiguille épicrânienne",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717765960/Products/Epicr%C3%A2nienne1_yvovsv.webp",
        "subtitle": "Aiguilles stériles pour prélèvement multiple de sang veineux",
        "description": "Les Aiguille épicrânienne sont des dispositifs médicaux stériles à usage unique. Elles sont composées d'une aiguille à ailettes reliée à une tubulure souple, se terminant par un raccord Luer Lock, permettant l'adaptation à la ligne de perfusion.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "aiguilles"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717766492/Products/Attelles_concaves_bfl0vc.webp",
        "category": "pansement",
        "target": "Chat/chien",
        "title": "Attelle concave",
        "promotion": false,
        "topSale": false,
        "newProduct": true,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717766493/Products/Attelles_concaves1_cjtuxj.webp",
        "subtitle": "Attelle concave en plastique de couleur rouge, bleu ou vert",
        "description": "Les attelles concaves en plastique, disponibles en rouge, bleu ou vert selon la taille, sont garnies d'une mousse de protection épaisse. Fabriquées dans une matière très résistante avec une finition poly-miroir, elles possèdent des bords rayonnés et une mousse dense débordante pour éviter de blesser l'animal. Plusieurs lignes de découpe permettent d'adapter l'attelle à la morphologie de l'animal. Des orifices d'aération le long de l'attelle assurent une meilleure circulation de l'air et réduisent la formation d'escarres",
        "specification": "[{\"Désignation\":\"Attelle bleu\",\"Taille\":\"20 cm\"},{\"Désignation\":\"Attelle rouge\",\"Taille\":\"30 cm\"},{\"Désignation\":\"Attelle vert\",\"Taille\":\"40 cm\"}]",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pansement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717769067/Products/Attelle_rouleau_cvhnrk.webp",
        "category": "pansement",
        "target": "Chat/chien",
        "title": "Attelle rouleau",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717769067/Products/Attelle_rouleau1_izw37j.webp",
        "subtitle": "Attelles rouleau d'aluminium recouvert d'une épaisseur de mousse sur les deux faces",
        "description": "Les attelles en rouleau sont composées d'aluminium recouvert d'une épaisseur de mousse sur les deux faces. Faciles à couper, elles se découpent à l'aide d'une paire de ciseaux mayo crantés pour s'ajuster à la taille du membre de l'animal. Radio-transparentes, elles sont souples et atraumatiques, épousant facilement la forme du membre à immobiliser. Disponibles en trois tailles: 45/250mm, 55/350mm et 90/400mm.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pansement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717771804/Products/Bande_jersey_mqikqr.webp",
        "category": "pansement",
        "target": "Usages divers",
        "title": "Bande jersey",
        "promotion": false,
        "topSale": false,
        "newProduct": true,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717771804/Products/Bande_jersey1_y9vbar.webp",
        "subtitle": "Tube jersey à usage sous bandes de contention",
        "description": "Tube jersey à usage sous bandes de contention, 100% coton, très élastique grâce à son mode de tissage. Son diamètre peut être triplé et il est perméable à l'air. Avec une densité de 70 mailles/cm², il peut être utilisé pour la fixation, sous les bandes plâtrées ou sous les bandes de coton adhésives. Disponible en trois tailles : 5 cm, 10 cm et 15 cm",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pansement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717769973/Products/Bande-pl%C3%A2tr%C3%A9e_kfvmei.webp",
        "category": "pansement",
        "target": "Usages divers",
        "title": "Bande plâtrée",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717769973/Products/Bande-pl%C3%A2tr%C3%A9e1_b8xkow.webp",
        "subtitle": "Bande plâtrée Fixogyps de prise ultra-rapide",
        "description": "La bande plâtrée Biplatrix offre une prise ultra-rapide en 105 à 130 secondes. Elle garantit un maintien idéal de la fracture grâce à sa haute résistance. Son temps de modelage optimal et son temps de séchage réduit facilitent l'application. Sans latex, elle ne provoque aucune allergie. Conditionnement : 2 bandes plâtrées par sachet. Disponible en deux tailles : 10 cm et 15 cm.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pansement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717772603/Products/bande_de_gaze_i6giey.webp",
        "category": "pansement",
        "target": "Usages divers",
        "title": "Bande de gaze",
        "promotion": false,
        "topSale": true,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717772604/Products/bande_de_gaze1_gtgynp.webp",
        "subtitle": "Tissu en coton composé de fils écartés",
        "description": "La bande de gaze est un tissu, généralement en coton, composé de fils écartés, ce qui la rend perméable à l'air et très respirante, favorisant ainsi la guérison. Elle garantit également une grande douceur sur la peau. Le coton utilisé est un coton hydrophile, c'est-à-dire qu'il possède une grande capacité d'absorption. Ce coton est traité chimiquement et ses fibres sont aérées pour une absorption optimale des liquides.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pansement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717834015/Products/Bande_cr%C3%AApe_vs1tgh.webp",
        "category": "pansement",
        "target": "Usages divers",
        "title": "Bandes de crêpe",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717834015/Products/Bande_cr%C3%AApe1_yx31uy.webp",
        "subtitle": "Bande Velpeau",
        "description": "Les bandes de crêpe Velpeau sont des bandes de tissu élastique utilisées pour le maintien de pansements sur diverses parties du corps. Aussi appelées bandes Velpeau, elles sont extensibles et parfaites pour la compression d'hémorragies et de saignements abondants. Composées à 100% de coton, elles permettent à la peau de respirer. Ces bandes s'adaptent à toutes les parties du corps, y compris les articulations et les masses musculaires. Elles sont emballées individuellement et disponibles en plusieurs dimensions : 7 cm x 3 m, 10 cm x 3 m, 15 cm x 3 m et 20 cm x 3 m.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pansement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717834849/Products/Coton_hydrophile_klshuj.webp",
        "category": "pansement",
        "target": "Usages divers",
        "title": "Coton hydrophile",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717834849/Products/Coton_hydrophile1_n4kchb.webp",
        "subtitle": "Coton Hydrophile 500g",
        "description": "Présentation économique et pratique en rouleau de 500 g, doux et très absorbant, adapté à tous les soins de la peau.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pansement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717837152/Products/Coton_Card%C3%A9_xdqq76.webp",
        "category": "pansement",
        "target": "Usages divers",
        "title": "Coton cardé",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717837152/Products/Coton_Card%C3%A91_tbajtn.webp",
        "subtitle": "Coton cardé en rouleau de 500 g.",
        "description": "Le coton cardé est un matériau doux et très absorbant, idéal pour une variété de soins de la peau. Présenté sous forme de rouleau économique et pratique de 500 g, il offre une grande facilité d'utilisation. Grâce à son processus de cardage, les fibres de coton sont alignées et nettoyées, assurant une texture uniforme et agréable au toucher. Adapté à tous les soins de la peau, le coton cardé est parfait pour le nettoyage, l'application de produits et le soin des plaies, garantissant une hygiène optimale et un confort maximal.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pansement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717837703/Products/Coton_orthop%C3%A9dique_xpnnjr.webp",
        "category": "pansement",
        "target": "Usages divers",
        "title": "Coton orthopédique",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717837702/Products/Coton_orthop%C3%A9dique1_vskupi.webp",
        "subtitle": "Rembourrage Orthopédique En Coton",
        "description": "Le rembourrage orthopédique est un bandage de protection synthétique, fabriqué à partir de tissu non tissé médical, de coton ou de polyester. Il est largement utilisé comme matériau d'amortissement pour les bandages en plâtre ou en fibre de verre, afin de protéger la peau et d'éliminer la chaleur. Principalement utilisé avant l'application du bandage en plâtre, il assure une protection optimale de la peau et aide à dissiper la chaleur.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pansement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717840055/Products/Bande_VETRAP_yjnjbm.webp",
        "category": "pansement",
        "target": "Usages divers",
        "title": "Bande VETRAP",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717840055/Products/Bande_VETRAP1_rneuj7.webp",
        "subtitle": "Bande élastique cohésive",
        "description": "Les Bandes VETRAP s'adhèrent sur elles-mêmes sans coller à la peau ou aux poils, ce qui les rend résistantes et agréables à poser. Elles se découpent à la main, sans besoin de ciseaux. Les straps band goût amer contiennent du benzoate de dénatonium, un agent répulsif au goût très amer, pour prévenir la mastication et le déchirement. Cette substance est également utilisée pour empêcher l'ingestion de produits ménagers et d'antigels, ainsi que dans les vernis à ongles pour lutter contre l'onychophagie. Le benzoate de dénatonium est considéré comme inoffensif sur la peau. Disponible en trois tailles : 5 cm x 4.5 m, 7.5 cm x 4,5 m et 10 cm x 4.5 m",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pansement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717841449/Products/Bande_adh%C3%A9sive_Adhe-els_i6auka.webp",
        "category": "pansement",
        "target": "Usages divers",
        "title": "Bande adhésive Adhe-els",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717841449/Products/Bande_adh%C3%A9sive_Adhe-els1_cclq8n.webp",
        "subtitle": "Bande élastique adhésive hypoallergénique Neolastic®",
        "description": "La bande élastique adhésive hypoallergénique Neolastic est conçue pour stabiliser, fixer et soutenir les zones soumises à de fortes contraintes, ainsi que pour maintenir les pansements et l'équipement médical en place. Hypoallergénique et offrant une haute tolérance cutanée, elle présente une haute adhérence, est extensible, respirante, résistante à l'eau et à la poussière, et permet une élimination indolore. Découpable selon les besoins de l'utilisateur, elle est perméable à l'air et à la vapeur d'eau, avec un allongement longitudinal ou transversal, garantissant un niveau d'hygiène optimal au niveau des plaies. Fabriquée dans un matériau souple pour plus de confort, elle est idéale pour une utilisation à court terme. Disponible en trois tailles : 8 cm, 10 cm et 15 cm.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pansement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717844163/Products/NEOPLAST_perfor%C3%A9_gln3ue.webp",
        "category": "pansement",
        "target": "Usages divers",
        "title": "Sparadrap NEOPLAST",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717844168/Products/NEOPLAST_perfor%C3%A9_1_nqcqbm.webp",
        "subtitle": "Rouleau Sparadrap NEOPLAST perforé",
        "description": "Le rouleau de sparadrap NEOPLAST perforé est un sparadrap à l'oxyde de zinc, offrant une forte adhérence. Il est perméable à l'air et résistant à l'eau et à la transpiration, assurant une bonne adhérence à la peau. Idéal pour la fixation de pansements et de compresses, il est disponible en deux dimensions : 2,5 cm x 5 m et 5 cm x 5 m.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pansement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717845772/Products/Sparadrap_NEOPLAST_perfor%C3%A9_zyc7ef.webp",
        "category": "pansement",
        "target": "Usages divers",
        "title": "Sparadrap NEOPLAST",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717845773/Products/Sparadrap_NEOPLAST_perfor%C3%A91_bxcecw.webp",
        "subtitle": "Sparadrap NEOPLAST perforé 18 cm x 5 m",
        "description": "Le sparadrap à l'oxyde de zinc perforé est un ruban adhésif médical recouvert d'une fine couche d'oxyde de zinc, conçu pour maintenir les pansements en place. Grâce à ses perforations, il permet à la peau de respirer et évite l'accumulation de sueur et d'humidité sous le pansement. Ce type de sparadrap est souvent utilisé pour fixer les pansements sur les plaies, les coupures et les brûlures légères.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pansement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717847714/Products/Compresses_chirurgicales_ezbvls.png",
        "category": "pansement",
        "target": "Usages divers",
        "title": "Compresses chirurgicales",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717847712/Products/Compresses_chirurgicales1_swelxi.png",
        "subtitle": "Compresse stérile non tissée",
        "description": "La compresse stérile, utilisée en milieu médical et lors des opérations, est recommandée pour les plaies suintantes ou saignantes. Non tissée et à 4 plis, elle évite les infections et possède une bonne capacité d'absorption, assurant un nettoyage optimal de la blessure.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pansement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717937147/Products/GREENCOL_srgq4p.webp",
        "category": "contention",
        "target": "Chat/chien",
        "title": "GREENCOL",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717937147/Products/GREENCOL1_mm3ue9.webp",
        "subtitle": "Colliers carcans en polypropylène transparent incolore.",
        "description": "Fixations rapides. 80% recyclé, 100% recyclable. Pourtour ondulé pour atténuer les chocs frontaux. Lignes anti-rayures en relief. Système d'attache rapide et sécurisé par un double passage des languettes. 3 à 5 réglages de tour du cou par taille. Protège la tête, l'abdomen et les membres. Attaches indépendantes se fixant sur le collier. Trou de stockage pour suspendre et retirer le collier choisi par simple traction quelle que soit sa position sur le support. Marquage vert foncé. Les encres utilisées sont conformes aux normes de la FDA : elles ne sont pas toxiques pour l'animal.",
        "specification": "[{\"Taille\":\"7.5 cm\",\"Tour de cou min\":\"25 cm\",\"Tour de cou max\":\"28 cm\"},{\"Taille\":\"10 cm\",\"Tour de cou min\":\"22 cm\",\"Tour de cou max\":\"28 cm\"},{\"Taille\":\"12.5 cm\",\"Tour de cou min\":\"25 cm\",\"Tour de cou max\":\"33 cm\"},{\"Taille\":\"15 cm\",\"Tour de cou min\":\"33 cm\",\"Tour de cou max\":\"41 cm\"},{\"Taille\":\"17.5 cm\",\"Tour de cou min\":\"35 cm\",\"Tour de cou max\":\"43 cm\"},{\"Taille\":\"20 cm\",\"Tour de cou min\":\"37\",\"Tour de cou max\":\"46 cm\"},{\"Taille\":\"25 cm\",\"Tour de cou min\":\"43 cm\",\"Tour de cou max\":\"52 cm\"},{\"Taille\":\"30 cm\",\"Tour de cou min\":\"47 cm\",\"Tour de cou max\":\"58 cm\"},{\"Taille\":\"35 cm\",\"Tour de cou min\":\"54 cm\",\"Tour de cou max\":\"70 cm\"},{\"Taille\":\"40 cm\",\"Tour de cou min\":\"62 cm\",\"Tour de cou max\":\"80 cm\"}]",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "contention canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717938441/Products/SMOCKY_arglaa.webp",
        "category": "contention",
        "target": "Chat/chien",
        "title": "SMOCKY®",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717938441/Products/SMOCKY1_fdxxph.webp",
        "subtitle": "Colliers carcans en polypropylène opaque incolore.",
        "description": "Fixations standard. Pourtour ondulé pour atténuer les chocs frontaux. Lignes anti-rayures en relief. Système d'attache classique sécurisé, une attache solidaire du carcan de l'animal, les autres se fixant individuellement sur le collier. 2 à 3 réglages de tour du cou par taille. Protège la tête, l'abdomen et les membres. Attaches indépendantes se fixant sur le collier. Trou de stockage pour suspendre et retirer le collier choisi par simple traction quelle que soit sa position sur le support. Marquage noir. Les encres utilisées sont conformes aux normes de la FDA : elles ne sont pas toxiques pour l'animal.",
        "specification": "[{\"Taille\":\"7.5 cm\",\"Tour de cou min\":\"25 cm\",\"Tour de cou max\":\"28 cm\"},{\"Taille\":\"10 cm\",\"Tour de cou min\":\"22 cm\",\"Tour de cou max\":\"28 cm\"},{\"Taille\":\"12.5 cm\",\"Tour de cou min\":\"25 cm\",\"Tour de cou max\":\"33 cm\"},{\"Taille\":\"15 cm\",\"Tour de cou min\":\"33 cm\",\"Tour de cou max\":\"41 cm\"},{\"Taille\":\"17.5 cm\",\"Tour de cou min\":\"35 cm\",\"Tour de cou max\":\"43 cm\"},{\"Taille\":\"20 cm\",\"Tour de cou min\":\"37\",\"Tour de cou max\":\"46 cm\"},{\"Taille\":\"25 cm\",\"Tour de cou min\":\"43 cm\",\"Tour de cou max\":\"52 cm\"},{\"Taille\":\"30 cm\",\"Tour de cou min\":\"47 cm\",\"Tour de cou max\":\"58 cm\"},{\"Taille\":\"35 cm\",\"Tour de cou min\":\"54 cm\",\"Tour de cou max\":\"70 cm\"},{\"Taille\":\"40 cm\",\"Tour de cou min\":\"62 cm\",\"Tour de cou max\":\"80 cm\"}]",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "contention canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717939334/Products/FUNCOL_g7wsbn.webp",
        "category": "contention",
        "target": "Chat/chien",
        "title": "FUNCOL®",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717939334/Products/FUNCOL1_pxpx0f.webp",
        "subtitle": "Colliers carcans en polypropylène transparent incolore, avec impression de motifs colorés en forme de pattes.",
        "description": "Fixations rapides. Pourtour ondulé pour atténuer les chocs frontaux. Lignes anti-rayures en relief. Système d'attache rapide et sécurisé par un double passage des languettes. 3 à 5 réglages de tour du cou par taille. Protège la tête, l'abdomen et les membres. Attaches indépendantes se fixant sur le collier. Trou de stockage pour suspendre et retirer le collier choisi par simple traction quelle que soit sa position sur le support.",
        "specification": "[{\"Taille\":\"7.5 cm\",\"Tour de cou min\":\"25 cm\",\"Tour de cou max\":\"28 cm\"},{\"Taille\":\"10 cm\",\"Tour de cou min\":\"22 cm\",\"Tour de cou max\":\"28 cm\"},{\"Taille\":\"12.5 cm\",\"Tour de cou min\":\"25 cm\",\"Tour de cou max\":\"33 cm\"},{\"Taille\":\"15 cm\",\"Tour de cou min\":\"33 cm\",\"Tour de cou max\":\"41 cm\"},{\"Taille\":\"17.5 cm\",\"Tour de cou min\":\"35 cm\",\"Tour de cou max\":\"43 cm\"},{\"Taille\":\"20 cm\",\"Tour de cou min\":\"37\",\"Tour de cou max\":\"46 cm\"},{\"Taille\":\"25 cm\",\"Tour de cou min\":\"43 cm\",\"Tour de cou max\":\"52 cm\"},{\"Taille\":\"30 cm\",\"Tour de cou min\":\"47 cm\",\"Tour de cou max\":\"58 cm\"}]",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "contention canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717939760/Products/TRANSCOL_qp632l.webp",
        "category": "contention",
        "target": "Chat/chien",
        "title": "TRANSCOL",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1717939760/Products/TRANSCOL1_ew0jm1.webp",
        "subtitle": "Colliers carcans en polypropylène transparent coloré.",
        "description": "Fixations rapides. Code couleur pour identifier les tailles. Pourtour ondulé pour atténuer les chocs frontaux. Lignes anti-rayures en relief. Système d'attache rapide et sécurisé par un double passage des languettes. 3 à 5 réglages de tour du cou par taille. Protège la tête, l'abdomen et les membres. Attaches indépendantes se fixant sur le collier. Trou de stockage pour suspendre et retirer le collier choisi par simple traction quelle que soit sa position sur le support. Marquage noir. Les encres utilisées sont conformes aux normes de la FDA : elles ne sont pas toxiques pour l'animal.",
        "specification": "[{\"Taille\":\"7.5 cm\",\"Tour de cou min\":\"25 cm\",\"Tour de cou max\":\"28 cm\"},{\"Taille\":\"10 cm\",\"Tour de cou min\":\"22 cm\",\"Tour de cou max\":\"28 cm\"},{\"Taille\":\"12.5 cm\",\"Tour de cou min\":\"25 cm\",\"Tour de cou max\":\"33 cm\"},{\"Taille\":\"15 cm\",\"Tour de cou min\":\"33 cm\",\"Tour de cou max\":\"41 cm\"},{\"Taille\":\"17.5 cm\",\"Tour de cou min\":\"35 cm\",\"Tour de cou max\":\"43 cm\"},{\"Taille\":\"20 cm\",\"Tour de cou min\":\"37\",\"Tour de cou max\":\"46 cm\"},{\"Taille\":\"25 cm\",\"Tour de cou min\":\"43 cm\",\"Tour de cou max\":\"52 cm\"},{\"Taille\":\"30 cm\",\"Tour de cou min\":\"47 cm\",\"Tour de cou max\":\"58 cm\"}]",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "contention canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718097654/Products/VACUUMAT_qkzork.webp",
        "category": "contention",
        "target": "Usages divers",
        "title": "VACUUMAT®",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718097654/Products/VACUUMAT1_apy3j9.webp",
        "subtitle": "Matelas de contention à vide d'air en polyuréthane extrêmement résistant.",
        "description": "Radiotransparent. Facilement lavable. Grande capacité de microbilles pour mieux épouser les formes de l'animal. Matière souple, agréable et très résistante. Idéal à utiliser lors de radiographie, IRM, scanner, échographie ou encore en chirurgie grâce à un système d'aspiration de l'air qui permet d'immobiliser complètement l'animal dans la position désirée. Isolant thermique. Valve de sécurité intégrée afin de maintenir le vide d'air au delà de 72H.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "contention canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718098592/Products/Cage_de_contention_ojm3kp.webp",
        "category": "contention",
        "target": "Usages divers",
        "title": "Cage de contention",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718098593/Products/Cage_de_contention1_qwtlkw.webp",
        "subtitle": "Cage de contention pour chats en fil d'acier peint, une ouverture haute et une ouverture latérale.",
        "description": "La cage de contention pour chats, de dimensions 44 x 30 x 29 cm, est équipée d'une grille de contention facilement manœuvrable de l'extérieur, avec deux ouvertures : une haute pour introduire l'animal et une latérale pour l'extraire. Robuste et fabriquée en fil d'acier peint de 2,5 mm de diamètre, elle possède une maille de 2,5 x 2,5 cm, resserrée près de la poignée pour protéger le manipulateur.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "contention canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718099870/Products/Gants_latex_gouxzk.webp",
        "category": "protection",
        "target": "Usages divers",
        "title": "Gants latex",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718099870/Products/Gants_latex1_j92pi0.webp",
        "subtitle": "Gants d'examen latex poudrés non stériles",
        "description": "Reconnus pour leur utilisation dans les milieux médicaux, les gants en latex légèrement poudrés s'enfilent facilement, offrant une sensation de seconde peau. Grâce à leur grande sensibilité tactile, ces gants jetables allient confort, souplesse et flexibilité. Possédant d'excellentes propriétés élastiques, ils offrent une performance fiable et une protection efficace contre les infections et la contamination. Disponibles en tailles S, M et L.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "protection canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718100443/Products/Gants_de_chirurgie_nm5hr3.webp",
        "category": "protection",
        "target": "Usages divers",
        "title": "Gants de chirurgie",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718100443/Products/Gants_de_chirurgie1_vhm8dm.webp",
        "subtitle": "Gants de chirurgie latex poudrés stériles ",
        "description": "Pour le confort et la sécurité en intervention, les gants de chirurgie en latex poudrés stériles offrent une qualité supérieure avec un excellent toucher et une forme anatomique. Fabriqués en latex de caoutchouc naturel et faiblement poudrés, ils sont adaptés à la chirurgie et aux soins médicaux stériles. Chaque paire est emballée de manière stérile, avec une pochette intérieure distincte pour la main droite et la main gauche.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "protection canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718103557/Products/Charlotte_jetable_j7rcqs.webp",
        "category": "protection",
        "target": "Usages divers",
        "title": "Charlotte jetable",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718103557/Products/Charlotte_jetable1_zinhmd.webp",
        "subtitle": "Charlotte non stérile à usage unique",
        "description": "Les charlottes jetables de protection sont conçues pour les milieux de travail où le respect des règles d'hygiène est primordial. Fabriquées en polypropylène et serrées par un élastique, elles sont légères et simples à utiliser, protégeant vos cheveux des petites salissures et s'adaptant à tous types de chevelure. Fortement recommandées dans les milieux médicaux, cosmétiques, agroalimentaires et les laboratoires, ces charlottes ont un diamètre de 53 cm et sont conditionnées à raison de 100 pièces par sachet.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "protection canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718177490/Products/Surchaussures_jetables_cfymsm.webp",
        "category": "protection",
        "target": "Usages divers",
        "title": "Surchaussures jetables",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718177490/Products/Surchaussures_jetables1_bvaqnv.webp",
        "subtitle": "Couvre chaussure jetable",
        "description": "Le couvre-chaussure jetable est un matériel de protection à usage unique permettant de recouvrir vos chaussures de travail. Majoritairement utilisé dans le secteur médical, il est également employé dans les laboratoires scientifiques, les usines agroalimentaires, les centres d'esthétique, les complexes sportifs, ainsi que dans les crèches et les écoles maternelles. Il garantit sécurité et stérilisation du matériel utilisé face à un public potentiellement exposé à des risques. Résistant à l'eau, le couvre-chaussure jetable est à la fois utile et économique, fabriqué en plastique et équipé d'un élastique pour une bonne tenue. Grâce à son revers en plastique, il évite l'humidité ambiante. Antidérapant, il assure une parfaite stabilité, facilitant les déplacements dans des environnements comme les hôpitaux et les laboratoires. Non tissé de 35 à 45 g/m², la partie supérieure est solide et hydrofuge, tandis que la partie inférieure est doublée par une semelle antidérapante et imperméable. ",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "protection canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718182860/Products/Sonde_v%C3%A9sicale_chien_yw8avv.webp",
        "category": "Sondes",
        "target": "Chiens",
        "title": "Sonde vésicale chien",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718182861/Products/Sonde_v%C3%A9sicale_chien1_iiucb8.webp",
        "subtitle": "Sonde urinaire plastique pour chiens",
        "description": "Sonde Vésicale pour Chien de haute qualité, spécialement conçue pour un usage vétérinaire. Fabriquée en silicone souple et hypoallergénique, cette sonde offre une insertion facile et sans risque, parfaitement adaptée à l'anatomie canine. Idéale pour le soulagement de l'obstruction urinaire, la collecte d'échantillons pour analyses et les interventions chirurgicales, la sonde vésicale garantit une sécurité optimale et un maximum de confort pour l'animal. Disponible en différentes tailles pour s'adapter à toutes les races, c'est l'outil indispensable pour tout professionnel soucieux de la santé animale.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "sondes urinaires"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718184197/Products/SONDES_V%C3%89SICALES_POLYPROPYLENE_xzltsq.webp",
        "category": "Sondes",
        "target": "Chiens",
        "title": "Sonde vésicale chien",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718184197/Products/SONDES_V%C3%89SICALES_POLYPROPYLENE1_hpth07.webp",
        "subtitle": "SONDES VÉSICALES POLYPROPYLENE",
        "description": "Les sondes vésicales en polypropylène sont des dispositifs semi-rigides conçus pour les chiens. Elles possèdent des extrémités fermées et arrondies avec deux orifices latéraux, et sont équipées d'une embase Luer. Ces sondes sont fournies sans mandrin.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "sondes urinaires"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718184790/Products/Sonde_v%C3%A9sicale_en_PVC_pour_chiennes_pq6ml6.webp",
        "category": "Sondes",
        "target": "chiennes",
        "title": "Sonde vésicale chienne",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718184790/Products/Sonde_v%C3%A9sicale_en_PVC_pour_chiennes1_bgn6ye.webp",
        "subtitle": "Sonde vésicale en PVC pour chienne.",
        "description": "Les sondes vésicales en PVC sont spécialement conçues pour les chiennes. Elles possèdent des extrémités fermées et arrondies avec deux orifices latéraux, ainsi qu'une embase Luer. Chaque sonde est emballée individuellement de manière stérile.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "sondes urinaires"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718185937/Products/UROLENE_CAT_gdhima.webp",
        "category": "Sondes",
        "target": "Chat",
        "title": "UROLENE® CAT",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718185937/Products/UROLENE_CAT1_x6gmug.webp",
        "subtitle": "Sondes vésicales stériles pour CHAT, sans DEHP.",
        "description": "Les sondes vésicales stériles UROLENE® CAT, sans DEHP, sont spécialement conçues pour les chats. Elles disposent d'une embase Luer-Lock avec une collerette rotative percée de quatre trous pour une fixation sécurisée. Le code couleur Génia permet d'identifier facilement les tailles. Ces sondes sont sans latex ni DEHP et offrent deux types d'extrémités : une extrémité fermée arrondie atraumatique avec deux œillets latéraux et une extrémité ouverte atraumatique pour faciliter le retrait du bouchon dans l'urètre, permettant un sondage plus rapide. Le mandrin est facile à remettre en place et ne bouge pas dans l'embase, et les sondes fermées sont disponibles avec ou sans mandrin.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "sondes urinaires"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718189977/Products/Sonde_chat_TOM_CAT_ui0prq.webp",
        "category": "Sondes",
        "target": "Chat",
        "title": "Sonde chat TOM CAT",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718189977/Products/Sonde_chat_TOM_CAT1_qmbjq0.webp",
        "subtitle": "Sondes vésicales stériles pour chat",
        "description": "Les sondes vésicales stériles TOM CAT pour chats sont conçues pour les interventions de sondage vésical et d'urétrostomie, et sont équipées de collerettes perforées amovibles. Elles possèdent une embase Luer et sont fournies sans mandrin.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "sondes urinaires"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718193588/Products/Boite_d_urgence_jp47g2.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Boite d'urgence",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718193589/Products/Boite_d_urgence1_vhfycp.webp",
        "subtitle": "Boite de chirurgie d'urgence",
        "description": "La boîte de chirurgie d'urgence proposée par MSA Santé Animale contient sept instruments destinés à un usage chirurgical, couvrant l'ensemble des besoins pour réaliser des actes chirurgicaux d'urgence, de l'incision à la pose des sutures, ainsi que des soins infirmiers. Fabriqués en acier inoxydable, ces instruments garantissent robustesse et durabilité, tout en étant facilement désinfectables et stérilisables. La boîte comprend : une boîte inox de 17 x 07 x 03 cm, une pince de dissection avec griffes de 13 cm, une pince de dissection sans griffes de 13 cm, des ciseaux Mayo droits de 14 cm, un bistouri fixe à manche plat de 14 cm, une pince Kocher droite avec griffes de 14 cm, une pince Kocher droite avec griffes de 12 cm et un porte-aiguille de Mayo-Hegar de 12 cm.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers chirurgie"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718195706/Products/Boite_de_chirurgie_scb5dp.png",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Boite de chirurgie",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718195725/Products/Boite_de_chirurgie1_utmrwb.png",
        "subtitle": "Boîtes de chirurgie en acier inoxydable",
        "description": "Boîtes de chirurgie en acier inoxydable, conçues pour offrir une solution de rangement pratique et hygiénique pour les instruments de chirurgie. Fabriquées avec un acier inoxydable de haute qualité, ces boîtes assurent une durabilité exceptionnelle et une résistance à la corrosion, garantissant ainsi la sécurité et la stérilité de outils médicaux. Avec un design épuré et fonctionnel, elles sont faciles à nettoyer et à entretenir, ce qui les rend idéales pour tout environnement médical. Disponibles en trois tailles pour s'adapter à vos besoins spécifiques : 20*9 cm , 25*10 cm et 15*30 cm.",
        "specification": "Boîtes de chirurgie en acier inoxydable",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers chirurgie"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718196869/Products/Plateau_inox_m%C3%A9dical_kalmed.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Plateau inox médical",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718196869/Products/Plateau_inox_m%C3%A9dical1_bylexa.webp",
        "subtitle": "Plateaux à instruments en acier inoxydable",
        "description": "Le plateau inox médical, en acier inoxydable de haute qualité, est très pratique pour organiser et disposer les petits instruments de chirurgie. Disponible en trois tailles : 22,5 x 15 cm, 27,5 x 17,5 cm, et 30 x 20 cm.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers chirurgie"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718199074/Products/Broche_de_Kirschner_yvxxdj.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Broche de Kirschner",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718199074/Products/Broche_de_Kirschner1_hvwfo1.webp",
        "subtitle": "Broches de Kirschner à double extrémité en acier inoxydable",
        "description": "Les broches de Kirschner à double extrémité en acier inoxydable sont des instruments vétérinaires orthopédiques essentiels pour réaliser l'ostéosynthèse des fractures des os longs des membres inférieurs et supérieurs, y compris les fractures diaphysaires et épiphysaires, ainsi que celles des os du carpe, du tarse, du métacarpe, et du métatarse. Elles sont également utilisées pour le traitement des ostéotomies, assurant une fixation solide et fiable dans diverses applications orthopédiques pour animaux domestiques.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers chirurgie"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718271866/Products/Fil_de_Cerclage_eazqcr.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Fil de Cerclage",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718271867/Products/Fil_de_Cerclage1_co87av.webp",
        "subtitle": "Fil de Cerclage en acier inoxydable",
        "description": "Le fil de cerclage en acier inoxydable est un instrument orthopédique vétérinaire essentiel pour stabiliser les fractures osseuses. Robuste et durable, il assure une fixation sécurisée et fiable des fragments osseux, facilitant ainsi la guérison. Utilisé couramment dans diverses procédures orthopédiques, il offre une résistance optimale à la traction et à la corrosion, garantissant des résultats efficaces et durables pour le traitement des animaux.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers chirurgie"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718275844/Products/pince_%C3%A0_bord_mousse_s8gtez.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Pince anatomique mousse",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718275844/Products/pince_%C3%A0_bord_mousse1_qzsejw.webp",
        "subtitle": "Pince à dissection Bouts mousse",
        "description": "La pince à dissection mousse en acier inoxydable, disponible en modèles de 14 cm et 18 cm, est utilisée en chirurgie et pour d'autres soins médicaux. Elle permet de manipuler et disséquer les tissus les plus fragiles sans engendrer de traumatismes, assurant une précision et une délicatesse optimales dans les interventions médicales.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Pinces"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718276400/Products/Pince_anatomique_%C3%A0_griffes_zw17ok.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Pince à griffes",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718276401/Products/Pince_anatomique_%C3%A0_griffes1_gfcnfb.webp",
        "subtitle": "Pince à dissection avec griffes",
        "description": "La pince à dissection avec griffes est une pince chirurgicale utilisée pour saisir, écarter ou présenter les tissus mous. Ses mors dotés de griffes assurent une excellente capacité de préhension et de manipulation, rendant cette pince particulièrement adaptée à une utilisation sur la peau en offrant une meilleure préhension et un traumatisme réduit par rapport aux modèles sans griffes. Fabriquée en acier inoxydable, cette pince médicale est autoclavable à 134°C pendant 18 minutes et peut être nettoyée en machine ou à la main avec un produit non agressif pour l'acier inoxydable.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Pinces"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718277563/Products/Pince_anatomique_pointue_ajvrln.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Pince anatomique pointue",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718277563/Products/Pince_anatomique_pointue1_grzw78.webp",
        "subtitle": "Pince à dissection fines / pointue sans griffes",
        "description": "Les pinces à dissection fines et pointues sans griffes sont des pinces médicales utilisées en petite chirurgie pour saisir et manipuler les tissus lors des dissections. Leurs formes effilées et leurs bouts pointus permettent une grande précision dans le geste, bien que leur capacité de préhension soit moins bonne que celle des modèles à griffes. Fabriquées en acier inoxydable, ces pinces anatomiques sont autoclavables à 134°C pendant 18 minutes et peuvent être nettoyées en machine ou à la main avec un produit non agressif pour l'acier inoxydable.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Pinces"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718279350/Products/Pince_h%C3%A9mostatique_droite_n0glqn.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Pince hémostatique droite",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718279350/Products/Pince_h%C3%A9mostatique_droite1_jmhzx3.webp",
        "subtitle": "Pince Kocher droite sans griffe",
        "description": "La pince Kocher droite a de nombreux usages. En chirurgie, elle sert à clamper des vaisseaux, monter des compresses et manipuler des tissus fragiles, tandis que lors de petits soins, elle est utilisée pour saisir et manipuler des pansements, dévisser des tubulures, etc. Avec sa forme de ciseaux et ses mors fins et rainurés sur toute leur longueur, elle se différencie de la classique pince Kocher par l'absence de griffes, rendant ainsi son utilisation moins traumatisante pour les tissus. Fabriquées en acier inoxydable, les pinces Kocher sont autoclavables à 134°C pendant 18 minutes et peuvent être nettoyées en machine ou à la main avec un produit non agressif pour l'acier inoxydable.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Pinces"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718281073/Products/Pince_courbe_wc3uxk.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Pince courbe",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718281074/Products/Pince_courbe1_rjgtk1.webp",
        "subtitle": "Pince courbe sans griffe",
        "description": "La pince courbe sans griffe est une pince hémostatique en acier inoxydable, conçue sous la forme de ciseaux avec des mors longs, fins et partiellement rainurés. Un système d'autoblocage permet de la maintenir en position fermée sans intervention manuelle. Maniable et précise, elle est utilisée pour clamper des vaisseaux sanguins ou des tubulures de perfusion, ainsi que pour saisir, tirer et manipuler des tissus, des compresses, des tampons, etc.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Pinces"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718282462/Products/Pince_courbe_avec_griffes_ejepbn.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Pince courbe avec griffe",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718282464/Products/Pince_courbe_avec_griffes1_qmx3bs.webp",
        "subtitle": "Pince courbe avec griffes",
        "description": "La pince courbe avec griffes est une pince médicale en acier inoxydable, dotée de mors avec griffes et crantés sur toute leur longueur, offrant une prise en main facile. Grâce à sa petite taille, sa forme de ciseaux, sa pointe fine et son système d'autoblocage par crémaillère, elle permet un travail précis et efficace pour réaliser des clamps ou saisir fermement des tissus, des compresses, etc. Cette pince hémostatique est autoclavable à 134°C pendant 18 minutes et peut être nettoyée en machine ou à la main avec un produit non agressif pour l'acier inoxydable.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Pinces"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718284028/Products/Pince_droite_avec_griffe_gtmt80.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Pince droite avec griffe",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718284029/Products/Pince_droite_avec_griffe1_lkm8oe.webp",
        "subtitle": "Pince Kocher droite avec griffe",
        "description": "La pince hémostatique de Kocher droite en acier inoxydable est principalement utilisée en chirurgie pour réaliser des hémostases et manipuler des tissus robustes tels que la peau et les muscles, mais elle n'est pas adaptée aux tissus fragiles ou aux hémostases fines en raison de sa griffe qui pourrait causer des dommages. En dehors du bloc opératoire, elle sert souvent de pince polyvalente pour diverses manipulations nécessitant une forte préhension, comme le clampage de tubulures de perfusion ou le pliage de compresses. Se présentant sous la forme de ciseaux avec des mors longs, fins, et rainurés sur toute leur longueur, dotés d'une griffe à l'extrémité, et combinée à un système d'autoblocage, cette pince empêche tout glissement lors de la préhension d'objets ou de tissus. Elle est autoclavable à 134°C pendant 18 minutes et se nettoie en machine ou à la main avec un produit non agressif pour l'acier inoxydable.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Pinces"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718285704/Products/Pince_%C3%A0_champs_mpxcqb.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Pince à champs",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718285725/Products/Pince_%C3%A0_champs1_rdhxjs.webp",
        "subtitle": "Pince à champs Backhaus",
        "description": "La pince à champs Backhaus est une pince chirurgicale équipée de deux griffes pointues, conçue pour fixer les compresses et délimiter les champs opératoires, assurant ainsi la protection de la zone chirurgicale.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Pinces"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718363200/Products/Pince_Brucelle_vwvjnb.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Pince Brucelle",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718363200/Products/Pince_Brucelle1_b90cti.webp",
        "subtitle": "Pince Brucelle coudée sans griffe",
        "description": "La pince anatomique de type Brucelle coudée sans griffe est utilisée pour des soins et des travaux de précision, facilitant la préhension et la manipulation d'éléments ou d'objets de petite taille. Fabriquée en acier inoxydable, cette pince médicale est autoclavable à 134°C pendant 18 minutes et se nettoie en machine ou à la main avec un produit nettoyant non agressif pour l'acier inoxydable.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Pinces"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718366455/Products/Pince_P%C3%A9an_br6oqc.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Pince Péan",
        "promotion": false,
        "topSale": false,
        "newProduct": true,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718366455/Products/Pince_P%C3%A9an1_n26msv.webp",
        "subtitle": "Pince hémostatique Péan Murphy",
        "description": "La pince hémostatique de type Péan Murphy est une pince droite en acier inoxydable, dotée de larges mors ovales avec des rainures perpendiculaires à l'axe des branches. Ces caractéristiques permettent de serrer efficacement les tissus, clamper les vaisseaux et manipuler les compresses sans risque d'écrasement ou de lésion. Son système de verrouillage maintient la pince en position fermée, facilitant ainsi son utilisation par le chirurgien ou l'infirmière. Avec sa forme de ciseaux-pince, elle offre une manipulation aisée. La pince Péan Murphy est autoclavable à 134°C pendant 18 minutes et se nettoie en machine ou à la main avec un produit non agressif pour l'acier inoxydable.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Pinces"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718367191/Products/Sonde_Cannel%C3%A9e_l8mqiv.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Sonde Cannelée",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718367193/Products/Sonde_Cannel%C3%A9e1_in1owa.webp",
        "subtitle": "Sonde de directeur",
        "description": "La sonde cannelée est un instrument de chirurgie utilisé notamment lors des dissections pour protéger les organes de la lame du bistouri ou des ciseaux. Fabriquée en acier inoxydable, elle est autoclavable à 134° C pendant 18 minutes, ce qui garantit une stérilisation efficace. Le nettoyage de la sonde peut être effectué en machine ou à la main avec un produit nettoyant n'attaquant pas l'acier inoxydable, assurant ainsi une hygiène optimale.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers chirurgie"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718369425/Products/Curette_fen%C3%AAtr%C3%A9e_qj7wxn.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Curette fenêtrée",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718369425/Products/Curette_fen%C3%AAtr%C3%A9e1_iceogo.webp",
        "subtitle": "Curette Besnier Lupus Fenêtrée",
        "description": "Les curettes Besnier Lupus en acier inoxydable sont conçues pour de petites interventions chirurgicales, notamment en pédicurie, afin de prélever ou retirer des tissus par curetage ou grattage. Disponibles en versions fenêtrées avec des dimensions de 3 et 4 mm, elles offrent une grande précision grâce à leur manche strié, qui permet une prise en main optimale.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers chirurgie"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718370335/Products/Porte-aiguilles_Mathieu_tw1wgf.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Porte-aiguilles Mathieu",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718370336/Products/Porte-aiguilles_Mathieu1_zebtj6.webp",
        "subtitle": "Pince porte aiguille Mathieu",
        "description": "Le porte-aiguilles Mathieu en acier inoxydable est un instrument chirurgical conçu pour tenir une aiguille lors de la réalisation de sutures. Doté de mâchoires rainurées pour une prise efficace sur l'aiguille, ses branches courbes et striées offrent une excellente prise en main. Son ressort à lame le maintient en position ouverte, et un système de verrouillage mécanique assure le blocage en position fermée. Il se nettoie en machine ou à la main avec un produit nettoyant n'attaquant pas l'acier inoxydable.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Pinces"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718371417/Products/ciseaux_Mayo_droits_polpzi.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Ciseaux Mayo Droits",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718371417/Products/ciseaux_Mayo_droits1_q7zit1.webp",
        "subtitle": "ciseaux chirurgicaux droits",
        "description": "Les ciseaux Mayo droits en acier inoxydable, avec leurs lames fines et biseautées et leurs bouts légèrement arrondis, sont parfaitement adaptés à la découpe sécurisée des fils de suture. Ils sont également utilisés lors des soins médicaux pour couper des pansements et des compresses. Leur design assure une manipulation précise et sécurisée, facilitant ainsi diverses procédures médicales.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "ciseaux"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718371797/Products/Ciseaux_Mayo_Courbes_euxcb7.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Ciseaux Mayo Courbes",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718371797/Products/Ciseaux_Mayo_Courbes1_dtzioi.webp",
        "subtitle": "Ciseaux chirurgicaux courbes",
        "description": "Ces ciseaux en acier inoxydable sont utilisés en chirurgie ou lors de petits soins médicaux pour couper des fils de suture, des pansements, etc. Pratiques ! Ces ciseaux sont dotés de lames biseautées permettant une découpe optimale des fils, au ras de la peau. Leurs bouts légèrement arrondis suppriment les risques de coupures du patient.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "ciseaux"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718372344/Products/Ciseaux_Metzembaum_Droits_f8u2r0.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Metzembaum Droits",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718372344/Products/Ciseaux_Metzembaum_Droits1_szng8a.webp",
        "subtitle": "Ciseaux à dissection droits",
        "description": "Les ciseaux de type Metzembaum droits sont des instruments essentiels lors des dissections pour écarter délicatement les tissus mous sans les endommager. Ils sont également utilisés pour la découpe précise des tissus et des bandages lors d'interventions chirurgicales ou de soins médicaux. Fabriqués en acier inoxydable, ces ciseaux sont dotés de deux lames fines à bout mousse, assurant une manipulation précise et sécurisée.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "ciseaux"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718373527/Products/Metzembaum_Courbes_qch3ex.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Metzembaum Courbes",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718373528/Products/Metzembaum_Courbes1_oyykid.webp",
        "subtitle": "Ciseaux Metzembaum Courbes",
        "description": "Ces ciseaux en acier inoxydable très fins sont spécialement conçus pour les petits soins et les interventions chirurgicales. Leurs deux lames courbes à bout mousse sont idéales pour disséquer les tissus mous en les écartant sans les endommager, offrant ainsi une précision maximale lors des procédures médicales.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "ciseaux"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718374550/Products/Ciseau_Costotome_hg5cds.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Ciseau Costotome",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718374551/Products/Ciseau_Costotome1_bucrku.webp",
        "subtitle": "Ciseau à costotomie",
        "description": "Le ciseau costotome est un instrument chirurgical utilisé principalement en chirurgie thoracique. Il est conçu spécifiquement pour la section des côtes lors d'interventions chirurgicales nécessitant l'accès à la cage thoracique, par exemple lors d'une thoracotomie (ouverture de la paroi thoracique) ou pour des procédures telles que la thoracoscopie. Le costotome est adapté pour couper et sectionner les côtes de manière précise tout en minimisant les dommages aux tissus environnants.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "ciseaux"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718871956/Products/Manche_de_Bistouri_dwtmpr.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Manche de Bistouri",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718871956/Products/Manche_de_Bistouri1_kyizu8.webp",
        "subtitle": "Manche porte-lame",
        "description": "Le manche de bistouri en acier inoxydable est à la fois robuste et ergonomique, garantissant une prise en main optimale pour des incisions précises en contexte chirurgical ou pour d'autres applications. Ce manche, fourni sans lame, est réutilisable et conçu pour accueillir des lames de bistouri à usage unique. Pour minimiser les risques de coupure, il est recommandé d'utiliser une pince ou un instrument équivalent lors de l'installation et du retrait des lames. Le manche est facilement décontaminable et stérilisable, assurant une hygiène irréprochable. Disponible en deux tailles : N°3 (compatible avec les lames N°10 à 15) et N°4 (compatible avec les lames N°20 à 24).",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers chirurgie"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718873109/Products/Ecarteur_de_Farabeuf_xfsi5u.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Ecarteur de Farabeuf",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718873110/Products/Ecarteur_de_Farabeuf1_rct1xg.webp",
        "subtitle": "Écarteur manuel",
        "description": "L'écarteur de Farabeuf est un instrument chirurgical couramment utilisé pour repousser ou maintenir en place les lèvres d'une incision. Cet écarteur à fonction statique est souvent utilisé par paire pour une meilleure efficacité. Fabriqué en acier inoxydable, il est robuste et facilement stérilisable. L'écarteur de Farabeuf a une largeur de 18 mm et est disponible en deux longueurs : 12 cm et 15 cm.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers chirurgie"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718874845/Products/Aiguille_%C3%A0_suture_fpdht4.webp",
        "category": "Chirurgie",
        "target": "Suture",
        "title": "Aiguille à suture",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718874845/Products/Aiguille_%C3%A0_suture1_h8of5c.webp",
        "subtitle": "Aiguille de suture chirurgicale",
        "description": "Les aiguilles à suture en acier inoxydable Reverse Cutting sont conçues pour des interventions chirurgicales nécessitant une précision accrue. Courbes à 3/8 de cercle, elles possèdent une pointe extra fine triangulaire et un chas large simple, ce qui facilite l'enfilage du fil. Leur forme spécifique les rend particulièrement idéales pour suturer des tissus difficiles à pénétrer, tout en minimisant les risques de déchirure des tissus. Robustesse et efficacité sont les maîtres mots de ces aiguilles de haute qualité.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "aiguilles de suture"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718876147/Products/Champ_Op%C3%A9ratoire_mdydga.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Champ Opératoire",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718876148/Products/Champ_Op%C3%A9ratoire1_davt4c.webp",
        "subtitle": "Champ Stérile Troué",
        "description": "Le champ stérile troué est conçu pour des soins ciblés particuliers ou des interventions de petite chirurgie. Utilisés à usage unique, ces champs permettent d'isoler la zone concernée, assurant une protection optimale pour le patient durant l'opération. Respectant les normes et réglementations médicales, ils sont fabriqués en tissu imperméable et très résistant, garantissant une stérilité complète pendant toute la durée de l'intervention. Ces champs sont essentiels pour maintenir un environnement stérile et sécurisé lors de soins médicaux ou chirurgicaux.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers chirurgie"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718877126/Products/fil_de_suture_wgsfvi.webp",
        "category": "Chirurgie",
        "target": "Suture",
        "title": "fil de suture",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718877126/Products/fil_de_suture1_u3ehm2.webp",
        "subtitle": "fil de suture résorbable",
        "description": "Les fils synthétiques tressés en polyglactine offrent une excellente tolérance et une résorption accélérée, ce qui les rend adaptés à de nombreux gestes chirurgicaux. La version monofilament synthétique en poliglecaprone se distingue par sa grande souplesse et élasticité, idéale pour des sutures nécessitant une flexibilité accrue. Le monofilament en polydioxanone, également souple et résistant, est particulièrement recommandé pour les interventions chirurgicales cardiovasculaires et la microchirurgie ophtalmique, avec une résorption de 180 à 210 jours. Le fil synthétique tressé en acide polyglycolique, quant à lui, est polyvalent. Sa surface glissante réduit la capillarité et assure une bonne tenue au nœud, avec une résorption complète en 60 à 90 jours.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers chirurgie"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718878042/Products/Lamelle_couvre_objet_jnx8gu.webp",
        "category": "prélèvements",
        "target": "Usages divers",
        "title": "Lamelle",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718878042/Products/Lamelle_couvre_objet_1_x1sivm.webp",
        "subtitle": "Lamelle couvre objet",
        "description": "Les lamelles couvre-objet en verre sont utilisées pour la protection des échantillons et des objectifs du microscope. Fabriquées en verre clair et pré-nettoyé, elles garantissent une observation précise et sans distorsion, tout en préservant la qualité des échantillons.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "prélèvements et examens"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718878765/Products/Lame_de_microscope_cakrvk.webp",
        "category": "Prélèvements",
        "target": "Usages divers",
        "title": "Lame de microscope",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718878765/Products/Lame_de_microscope1_jqrj2r.webp",
        "subtitle": "Lame porte-objet",
        "description": "Les lames porte-objet pour microscope sont conçues en verre optique de haute qualité pour une clarté et une précision exceptionnelles. Ces lames offrent une surface plane idéale pour toutes vos préparations d'échantillons. Les bords polis assurent une manipulation sécurisée, rendant ces lames parfaites pour les laboratoires, les établissements éducatifs et les passionnés de microscopie.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "prélèvements et examens"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718880338/Products/Lame_de_bistouri_jnmgf5.webp",
        "category": "Chirurgie",
        "target": "Usages divers",
        "title": "Lame de bistouri",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718880338/Products/Lame_de_bistouri1_nsst2i.webp",
        "subtitle": "Lame de bistouri chirurgicale",
        "description": "Lames de bistouri de haute qualité, disponibles en tailles 11 et 24, parfaites pour des incisions précises et efficaces en chirurgie. Fabriquées en acier inoxydable, ces lames offrent une netteté exceptionnelle et une durabilité remarquable, répondant aux besoins des professionnels de la santé pour diverses interventions chirurgicales.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers chirurgie"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718885749/Products/crachoir_pgzoyj.webp",
        "category": "Prélèvements",
        "target": "Usages divers",
        "title": "Crachoir",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718885742/Products/crachoir1_hqjhoq.webp",
        "subtitle": "Crachoir à usage unique en plastique",
        "description": "Les crachoirs à usage unique en plastique sont fabriqués en polyéthylène blanc et destinés à recueillir les crachats pour des analyses. Utilisés principalement dans les hôpitaux, les cabinets médicaux et les laboratoires d'analyses médicales, ils sont conçus pour une sécurité optimale. Leur couvercle en polyéthylène rouge assure une fermeture étanche, permettant une manipulation sans risque.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "prélèvements et examens"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718886259/Products/%C3%A9couvillon_st%C3%A9rile_febk4c.webp",
        "category": "Prélèvements",
        "target": "Usages divers",
        "title": "Ecouvillon stérile",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718886245/Products/%C3%A9couvillon_st%C3%A9rile1_iaeylr.webp",
        "subtitle": "Bâtonnets écouvillon stériles",
        "description": "Les bâtonnets écouvillon stériles sont des cotons-tiges à usage unique composés d'une tige en plastique de 15 cm de longueur et d'un embout en coton hydrophile sec avec un diamètre de 0,5 cm. Chaque écouvillon est stérile et emballé individuellement, garantissant sa préparation pour les prélèvements dès son ouverture. De plus, l'emballage est muni d'une étiquette pratique permettant de noter les données relatives au patient.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "prélèvements et examens"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718887981/Products/Tubes_EDTA_eiadfk.png",
        "category": "Prélèvements",
        "target": "Usages divers",
        "title": "Tubes EDTA",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718887979/Products/Tubes_EDTA1_rutans.png",
        "subtitle": "Tubes de collecte de sang à EDTA",
        "description": "Les tubes EDTA, indispensables pour la collecte et la conservation des échantillons sanguins, sont disponibles en taille standard de 5 ml. Ces tubes contiennent un anticoagulant, l'EDTA, qui maintient l'intégrité des cellules sanguines en empêchant la coagulation, assurant ainsi des résultats d'analyse précis et fiables. Adaptés aux besoins des laboratoires médicaux et de recherche, ils garantissent une manipulation sûre et efficace des échantillons jusqu'à leur traitement ultérieur.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "prélèvements et examens"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718890445/Products/Tubes_H%C3%A9parine_osgeyg.webp",
        "category": "Prélèvements",
        "target": "Usages divers",
        "title": "Tubes Héparine",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718890445/Products/Tubes_H%C3%A9parine1_sf3i7u.webp",
        "subtitle": "Tubes de collecte de sang à héparine",
        "description": "Tubes en polypropylène étiquetés et bouchés. L'héparine agit comme anticoagulant en inhibant l'action de la thrombine. Etiquetés avec flèche de limite de remplissage, identification, numéro de lot et date de péremption. Anticoagulant pulvérisé à l'intérieur du tube rendant plus rapide le mélange avec le sang.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "prélèvements et examens"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718891458/Products/Bandelettes_urinaire_f4gpw6.webp",
        "category": "Examen",
        "target": "Usages divers",
        "title": "Bandelettes urinaire",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718891458/Products/Bandelettes_urinaire1_vqgynz.webp",
        "subtitle": "Bandelettes du test urinaire à 10 paramètres",
        "description": "Les bandelettes du test urinaire à 10 paramètres Acon Mission sont essentielles pour l'analyse de l'urine, permettant de détecter divers composants tels que les Leucocytes, Nitrites, Urobilinogène, Protéines, pH, Sang, Densité, Corps Cétoniques, Bilirubine et Glucose. Elles jouent un rôle crucial dans l'évaluation de la santé générale du patient, notamment de ses fonctions métaboliques, hépatiques et rénales, tout en offrant une méthode de dépistage économique et efficace. Ces bandelettes réactives colorimétriques assurent une fiabilité élevée et des performances comparables aux leaders du marché. Leur utilisation est simple : après avoir été en contact avec une petite quantité d'urine, les bandes réactives développent des couleurs spécifiques qui sont ensuite comparées à une échelle de couleurs pour obtenir les résultats précis des différents paramètres mesurés. Ce processus permet un diagnostic rapide et précis, essentiel pour une prise en charge médicale appropriée.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "prélèvements et examens"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718893215/Products/Sonde_endotrach%C3%A9ale_wcgkbs.webp",
        "category": "Anesthésie",
        "target": "Usages divers",
        "title": "Sonde endotrachéale",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718893215/Products/Sonde_endotrach%C3%A9ale1_xpqmsu.webp",
        "subtitle": "Sonde endotrachéale avec ballonnet",
        "description": "La sonde endotrachéale pour l'anesthésie et la réanimation est fabriquée en PVC transparent, sans latex, et stérile. Elle est équipée d'un ballonnet à basse pression pour une utilisation nasale ou orale. Le raccord est préassemblé avec une valve compatible avec les seringues à embout Luer et Luer-Lock. L'extrémité est atraumatique et arrondie, avec une ligne ORX sur toute sa longueur pour faciliter l'orientation lors de l'intubation. Un anneau de repère noir est présent pour contrôler la profondeur d'intubation, tandis que le ballonnet de contrôle est marqué en bleu et gradué pour permettre un gonflage précis.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718894228/Products/Lance-pilule_rirowv.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Lance pilules",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718894228/Products/Lance-pilule1_wtf7q5.webp",
        "subtitle": "Lance-pilule en PVC pourvu d'un embout souple sécurisé.",
        "description": "Le lance-pilule en PVC est conçu pour administrer facilement un comprimé aux chats ou aux petits chiens, avec une manipulation d'une seule main. Doté d'un embout souple sécurisé et non traumatique, il assure un confort optimal lors de l'utilisation. Étanche, il peut être utilisé avec de l'eau pour favoriser la déglutition, rendant l'administration des médicaments plus facile et efficace.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718896001/Products/Lecteur_de_puce_cxusk0.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Lecteur de puce",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718896001/Products/Lecteur_de_puce1_mvbupy.webp",
        "subtitle": "Lecteur de puce électronique transpondeur Halo pour chiens et chats",
        "description": "Le lecteur transpondeur Halo permet l'identification de la majorité des puces posées par les vétérinaires, ce qui le rend recommandé par les éleveurs, vétérinaires, refuges et fourrières pour une identification facilitée. Il lit toutes les puces FDX-B (15 digits) et FDX-A (10 digits) conformes aux normes ISO 11784 et ISO 11785. Lorsque la batterie est faible, un message 'Battery Low' apparaît sur l'écran. Pour recharger la batterie, il suffit de connecter la prise située à l'arrière du lecteur à un port USB valide de l'ordinateur sur lequel le logiciel est installé. Tant que le PC est connecté à Internet, le lecteur télécharge automatiquement le fichier des numéros des animaux signalés comme perdus dans sa mémoire. Le lecteur Halo peut mémoriser les 2000 derniers numéros scannés, offrant une gestion pratique et efficace des identifications.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718896782/Products/Thermom%C3%A8tre_%C3%A9lectronique_tno89o.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Thermomètre électronique",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718896782/Products/Thermom%C3%A8tre_%C3%A9lectronique1_dlp7sc.webp",
        "subtitle": "Thermomètre digital électronique",
        "description": "Le thermomètre digital est un dispositif médical conçu pour mesurer la température corporelle, utilisable tant en milieu hospitalier qu'à domicile. Doté d'un unique bouton, il est très simple d'utilisation. La prise de température s'effectue en 30 à 60 secondes, signalée par un bip sonore, et le résultat s'affiche clairement à l'écran pour une lecture aisée. Pratique, il s'éteint automatiquement après 10 minutes d'inutilisation. Ce thermomètre électronique permet des mesures orales, axillaires et rectales, la voie rectale étant la plus précise pour déterminer la température centrale du corps. Après chaque utilisation, il est recommandé de nettoyer l'embout à l'eau tiède et au savon, puis de le désinfecter avec de l'alcool à 70°, ou d'utiliser des étuis jetables à usage unique.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718897365/Products/Lasso_pxqs93.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Lasso",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718897364/Products/Lasso1_soij5o.webp",
        "subtitle": "Lasso de contention pour chiens ",
        "description": "Le lasso pour attraper les chiens est un dispositif constitué d'un câble coulissant attaché à un bâton robuste, conçu pour les professionnels de la manipulation des animaux. Il permet de rétracter, retenir et contrôler les animaux en toute sécurité en serrant le câble autour de la tête et du cou de l'animal. L'utilisation de ce lasso s'est avérée être le moyen le plus positif et efficace pour attraper un chien errant, sauver un chien piégé ou en détresse, ou traiter en toute sécurité et humainement un chien hostile. L'animal peut ainsi être saisi et retenu à une distance sûre. Pour utiliser le lasso, placez la boucle autour du cou du chien et tirez sur le câble pour serrer la pince. Elle se verrouille instantanément dans la position requise. Si une boucle plus grande est nécessaire, tirez sur le bouton métallique à l'extrémité de la pince pour ajuster le câble. Le chien peut alors être maintenu en toute sécurité jusqu'à son transfert dans une camionnette ou un chenil. Le mécanisme de libération rapide permet de libérer instantanément l'animal dans un environnement sûr en tirant sur l'anneau.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718958240/Products/SAPHIR_CORD_ftnsct.webp",
        "category": "Divers",
        "target": "Toilettage",
        "title": "SAPHIR CORD",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718958240/Products/SAPHIR_CORD1_s0bxuf.webp",
        "subtitle": "Tondeuse SAPHIR CORD",
        "description": "La tondeuse SAPHIR CORD combine puissance et style pour offrir des performances optimales. Dotée d’un câble de 3 mètres, cette tondeuse sur secteur facilite les travaux de tonte sur divers animaux, notamment les chiens, chats, bovins, et autres nécessitant des soins vétérinaires. Elle est encore plus rapide et maniable que les modèles Saphir sans fil. Avec une puissance impressionnante de 3200 oscillations par minute, la SAPHIR CORD se distingue par son efficacité. Elle devient rapidement un outil indispensable pour la tonte professionnelle des petits animaux grâce à son moteur silencieux de 35 W à aimants permanents, qui assure un confort optimal pour le tondeur et réduit le stress des animaux.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718966048/Products/SAPHIR_HEINIGER_imxl4d.webp",
        "category": "Divers",
        "target": "Toilettage",
        "title": "SAPHIR HEINIGER",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718966048/Products/SAPHIR_HEINIGER1_oxq9af.webp",
        "subtitle": "Tondeuse SAPHIR HEINIGER sans fil",
        "description": "La tondeuse HEINIGER SAPHIR sans fil est un outil puissant et innovant, indispensable pour la tonte professionnelle des petits animaux et les finitions sur chevaux et bovins. Livrée avec un peigne de 1,5 mm, une station de recharge, deux batteries, de l'huile, une brosse et un mode d'emploi, cette tondeuse offre une grande praticité et efficacité. Son moteur de 35 W à aimants permanents est à la fois silencieux et puissant, garantissant une expérience de tonte agréable et sans stress pour les animaux. La station de recharge de qualité supérieure est équipée d'un dock supplémentaire pour une deuxième batterie et d'un indicateur de charge. Les deux batteries haute performance, dotées de la technologie lithium-ion, permettent une autonomie de tonte de plus de 120 minutes pour un temps de chargement de moins de 60 minutes. Une batterie de remplacement est disponible en option sous la référence 9U707771. Avec une vitesse moteur de 2650 tours par minute et un poids de seulement 425 g, la SAPHIR sans fil est ultra légère, solide, durable, silencieuse et élancée, offrant une ergonomie optimale pour l'utilisateur. Les dimensions compactes de 204 x 50 x 41 mm facilitent la manipulation de l'appareil, tandis que la large sélection de têtes de coupe interchangeables permet des finitions variées et précises.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718966740/Products/SAPHIR_STYLE_gmkxpd.webp",
        "category": "Divers",
        "target": "Toilettage",
        "title": "SAPHIR STYLE",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718966740/Products/SAPHIR_STYLE1_puy2ps.webp",
        "subtitle": "TONDEUSE SANS FIL HEINIGER SAPHIR STYLE",
        "description": "La tondeuse Saphir Style de Heiniger est une tondeuse professionnelle de finition qui garantit un résultat parfait. Puissante et novatrice, elle devient un outil indispensable pour la tonte professionnelle des petits animaux. Dotée d'un moteur de 35 W à aimants permanents, elle est silencieuse et puissante. Elle est livrée avec un chargeur de haute qualité, incluant un témoin de charge et un box de chargement supplémentaire pour les accumulateurs. Les deux accumulateurs performants, utilisant la technologie lithium-ionisée, permettent une tonte de plus de 120 minutes pour moins de 60 minutes de chargement par batterie. La tondeuse offre une grande sélection de têtes de coupe interchangeables, et une batterie de remplacement est disponible en option (référence 9U707771). Unique en son genre, elle est solide, durable, silencieuse, élancée, ergonomique, ultra légère et stylée. Livrée avec un peigne de 1,5 mm, une station de recharge, deux batteries, de l'huile, une brosse et un mode d'emploi, la tondeuse est également garantie 2 ans. Ses données techniques incluent une puissance moteur de 35 W, une vitesse de 2650 oscillations par minute, des dimensions de 204 x 50 x 41 mm, un poids de 425 g incluant la batterie, un voltage de 7,4 V et une capacité de 1400 mAh.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718973817/Products/Pilosan_zo72kq.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Chat/chien",
        "title": "Pilosan",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718973817/Products/Pilosan1_cyun5k.webp",
        "subtitle": "Complément alimentaire pour chien et chat.",
        "description": "Pilosan de Vetexpert est un complément alimentaire spécialement formulé pour améliorer la santé de la peau et du pelage chez les chiens et les chats. Ce produit contient une combinaison d'ingrédients bénéfiques tels que l'huile de bourrache, riche en acides gras oméga-6, qui hydrate et assouplit la peau, ainsi que l'huile de poisson, contenant des oméga-3 comme l'EPA et le DHA, reconnus pour leurs propriétés anti-inflammatoires. Le zinc, un oligo-élément essentiel, joue un rôle crucial dans la cicatrisation des plaies, tandis que les vitamines du groupe B sont importantes pour le métabolisme des acides gras, favorisant ainsi une peau saine et un pelage brillant. La biotine, quant à elle, aide à réguler la production de sébum, ce qui est particulièrement bénéfique pour les animaux souffrant de séborrhée. Pilosan est conçu pour soutenir une peau hydratée, résistante et un pelage de qualité, tout en aidant à gérer les affections cutanées et à promouvoir la santé globale de la peau.",
        "specification": '',
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718975191/Products/BioProtect_acuaid.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Chat/chien",
        "title": "BioProtect",
        "promotion": false,
        "topSale": false,
        "newProduct": true,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718975191/Products/BioProtect_1_ri7ojx.webp",
        "subtitle": "Complément alimentaire pour chien et chat.",
        "description": "BioProtect est une nouvelle préparation conçue pour soutenir la microflore gastro-intestinale de vos chiens et chats, en particulier ceux souffrant de troubles digestifs. Recommandé par les vétérinaires, BioProtect inhibe la croissance des bactéries pathogènes, maintenant ainsi un tube digestif sain. Il régule et favorise également la microflore bénéfique, essentielle pour une digestion optimale et un bien-être général. En renforçant l'immunité non spécifique, BioProtect réduit le risque de diarrhée et améliore la résistance contre les troubles digestifs. Ce produit est idéal en complément d'une antibiothérapie pour restaurer l'équilibre de la microflore intestinale, en cas de diarrhée pour soutenir la santé digestive, après une vermifugation pour rétablir la microflore bénéfique, et à titre prophylactique pour les animaux en croissance ou sujets à la constipation. BioProtect est reconnu pour sa confiance et ses recommandations par les vétérinaires, assurant ainsi le bien-être digestif optimal de vos animaux.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718976239/Products/Urocline_Stones_bjds6s.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Chat/chien",
        "title": "Urocline Stones",
        "promotion": false,
        "topSale": false,
        "newProduct": true,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718976239/Products/Urocline_Stones1_ce1syl.webp",
        "subtitle": "Complément alimentaire pour chien et chat.",
        "description": "VetExpert Urocline Stones est un complément alimentaire novateur spécialement conçu pour favoriser un système urinaire sain chez les chats et soulager les inconforts urinaires. Ce produit intègre des ingrédients naturels et bénéfiques, tels que la DL-méthionine, un acidifiant efficace pour maintenir une urine saine. La glucosamine soutient la santé de la muqueuse urinaire, tandis que la canneberge est reconnue pour ses propriétés favorables au système urinaire. L'ortie et le persil contribuent à un bon fonctionnement urinaire, et la valériane aide à réduire le stress souvent lié aux problèmes urinaires. Enrichi en vitamine C et en vitamine B6, essentielles pour un métabolisme sain, Urocline Stones assure un fonctionnement urinaire optimal. Sa formule appétente garantit une prise facile et sans stress, soutenant ainsi le confort et le bien-être urinaire de votre chat.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718976926/Products/NoProl_s34sve.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Chiennes",
        "title": "NoProl",
        "promotion": false,
        "topSale": false,
        "newProduct": true,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718976926/Products/NoProl1_bnpl9q.webp",
        "subtitle": "Complément alimentaire pour Chiennes.",
        "description": "NoProl de VetExpert est le nouveau complément alimentaire de MSA Santé Animale conçu pour aider les chiennes présentant des signes de grossesse nerveuse. Ce produit utilise des ingrédients naturels pour offrir un soutien efficace et améliorer le bien-être de votre compagnon. Le gattilier combat la prolactine, l'hormone responsable de la montée de lait et des comportements maternels. Le pissenlit, grâce à ses propriétés diurétiques naturelles, aide à gérer la production de lait, tandis que l'extrait de persil renforce cet effet pour un soutien optimal. L'aescine, issue du marron d'Inde, réduit l'inflammation et les œdèmes, apportant ainsi un confort supplémentaire. Disponible en tailles S et XL, NoProl est une solution simple, naturelle et efficace pour des moments plus sereins. ",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718977798/Products/Art-ASUH_wzrrwy.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Chat/chien",
        "title": "Art-ASUH",
        "promotion": false,
        "topSale": true,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1718977797/Products/Art-ASUH1_vg0ony.webp",
        "subtitle": "Complément alimentaire pour chien et chat.",
        "description": "Art-ASUH de VetExpert représente un soutien articulaire avancé conçu pour améliorer la mobilité et le confort des chiens et des chats. Ce complément alimentaire est formulé avec une combinaison précise d'ingrédients tels que la glucosamine, la chondroïtine, et l'acide hyaluronique, qui favorisent la régénération et la résilience du cartilage articulaire. Les extraits d'Harpagophytum procumbens et les insaponifiables d'avocat et de soja apportent des propriétés anti-inflammatoires naturelles, aidant à réduire les symptômes de raideur et d'inconfort articulaire. Les antioxydants comme la vitamine C, le manganèse, le cuivre et le zinc soutiennent la santé globale des articulations en protégeant contre les dommages oxydatifs et en favorisant la synthèse du collagène. Avec l'ajout de L-carnitine pour soutenir un poids corporel optimal, Art-ASUH offre une approche complète pour maintenir la mobilité et le bien-être articulaire à long terme chez les animaux.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719391092/Products/Seringue_%C3%A0_insuline_zqpdvn.webp",
        "category": "Injection",
        "target": "Usages divers",
        "title": "Seringue à insuline",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719391092/Products/Seringue_%C3%A0_insuline1_qc4k9h.webp",
        "subtitle": "Seringue à insuline avec aiguille sertie",
        "description": "La seringue à insuline avec aiguille sertie, sans latex et à usage unique. D'une capacité de 1 ml, elle est graduée jusqu'à 100 unités, ce qui la rend idéale pour l'injection de petites doses.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "seringues"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719392416/Products/DERMASTEEL_selvhn.webp",
        "category": "Injection",
        "target": "Usages divers",
        "title": "DERMASTEEL",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719392416/Products/DERMASTEEL1_cap40q.webp",
        "subtitle": "Aiguilles hypodermiques",
        "description": "Les aiguilles hypodermiques DERMASTEEL en acier inoxydable sont dotées de parois renforcées pour une qualité supérieure. Elles possèdent un triple biseau et une conicité de 6% Luer-Lock, avec une embase de 14 mm. Ces aiguilles sont livrées en boîte de 12.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "aiguilles"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719394311/Products/Seringue_Metalplex_ldtetf.webp",
        "category": "Injection",
        "target": "Usages divers",
        "title": "Seringue Metalplex ",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719394311/Products/Seringue_Metalplex1_jxyjwr.webp",
        "subtitle": "Seringue Metalplex en plastique moulé",
        "description": "La seringue Metalplex en plastique moulé est fournie en standard avec une connexion Luer Lock. Traité contre la déformation, elle dispose d'une graduation gravée pour une précision accrue. Son piston, capuchon et tige sont en laiton nickelé, ce qui la rend adaptée à tous les produits pharmaceutiques standards. Équipée d'anneaux en silicone, la seringue est entièrement démontable pour faciliter le nettoyage et peut être stérilisée à l'eau bouillante.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "seringues"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719395019/Products/Seringue_Dosiplex_nqh10d.webp",
        "category": "Injection",
        "target": "Usages divers",
        "title": "Seringue Dosiplex ",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719395020/Products/Seringue_Dosiplex1_kdrwhc.webp",
        "subtitle": "Seringues hypodermiques indéformables",
        "description": "Seringues hypodermiques indéformables, similaires aux modèles Metalplex® et Elplex®, conçues avec un curseur pour une utilisation précise. Elles sont résistantes à l'eau bouillante et peuvent être stérilisées à l'autoclave jusqu'à 134°C (30 min - 1,5 bars). Compatibles avec les produits pharmaceutiques courants, ces seringues disposent de joints plats en silicone, biseautés, très résistants, hydrophobes et anti-adhérents, garantissant une étanchéité parfaite et un glissement léger du piston. Les embases sont centrées et les chapeaux sont renforcés en plastique transparent. Les axes-béquilles sont en zamac chromé avec méplat et graduations en relief, et les pistons sont en laiton nickelé.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "seringues"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719395949/Products/JOINTS_DE_SERINGUES_uhg3x3.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "JOINTS DE SERINGUES",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719395951/Products/JOINTS_DE_SERINGUES1_rvy2ym.webp",
        "subtitle": "Joint de piston pour seringues",
        "description": "Les joints de seringues sont compatibles avec les seringues Géniaplex normales et automatiques, Metalplex®, Elplex®, Polymex, Tubmatic®, Flamatic® et Drugmatic, ainsi que les modèles en plastique, les seringues à curseur et les seringues rallongées normales et automatiques. Ils sont principalement plats et en silicone, à l'exception des modèles 0,3 et 0,5 mL qui sont en nitrile de forme torique. Ces joints, moulés selon les normes Génia, sont biseautés, très résistants, avec un nombre de shore constant et uniforme sur toute la surface. Hydrophobes et anti-adhérents, ils assurent une étanchéité parfaite et un glissement léger du piston.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers injection"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719397411/Products/Seringue_Ukaplex_gafi3x.webp",
        "category": "Injection",
        "target": "Usages divers",
        "title": "Seringue Ukaplex",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719397412/Products/Seringue_Ukaplex1_ba5fw1.webp",
        "subtitle": "Seringue Uka-Plex Luer Lock",
        "description": "La seringue Ukaplex, équipée d'un embout Luer Lock, est une seringue économique à usages multiples. Conçue pour résister à l'ébullition et à la stérilisation à froid, elle est dotée d'un piston, d'un couvercle, et d'une poignée synthétique. Pour assurer une performance optimale, il est essentiel de bien nettoyer la seringue après chaque utilisation, de la rincer abondamment à l'eau claire et de la lubrifier avec de l'huile silicone (réf. 110 039). Les joints doivent être changés régulièrement pour maintenir l'étanchéité et l'efficacité de la seringue. Il est important de noter que cette seringue ne doit pas être passée en autoclave. Vendue à l'unité.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "seringues"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719398062/Products/HSW_MULTI-MATIC_r7wlji.webp",
        "category": "Injection",
        "target": "Usages divers",
        "title": "HSW MULTI-MATIC",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719398062/Products/HSW_MULTI-MATIC1_lbsic2.webp",
        "subtitle": "Pistolet à répétition pour dosages multiples de bétail 25 ml / 50 ml",
        "description": "HSW MULTI-MATIC® est une seringue haut de gamme conçue pour allier durabilité et légèreté. Sa poignée est fabriquée en aluminium moulé sous pression, offrant une durabilité exceptionnelle tout en restant légère. Le corps est en plastique durable de qualité médicale, complété par un raccord d'aiguille en métal, ce qui rend l'ensemble biocompatible et autoclavable (jusqu'à 134°C / 273°F). Cette seringue est chimiquement résistante à tous les médicaments connus, résiste aux UV et est incassable. Elle garantit un dosage exceptionnellement précis avec une tolérance de moins de 1%, et permet un réglage facile de la dose via une roue doseuse de 0,5 ml (pour les modèles de 25 ml) ou de 1 ml (pour les modèles de 50 ml). La conception de la HSW MULTI-MATIC® est simplifiée, nécessitant peu de pièces de rechange, et son design ergonomique assure une utilisation facile.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pistolets"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719399551/Products/HSW_ECO-MATIC_wqaqyb.webp",
        "category": "Injection",
        "target": "Usages divers",
        "title": "HSW ECO-MATIC",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719399551/Products/HSW_ECO-MATIC1_rjygvz.webp",
        "subtitle": "Pistolet HSW ECO-MATIC® avec adaptateur pour flacon",
        "description": " HSW ECO-MATIC® est une seringue automatique de précision en plastique premium, conçue pour offrir une grande durabilité et performance. Dotée d'un cylindre en plastique haute résistance et d'un panier en plastique pour flacons jusqu'à 100 ml, cette seringue est idéale pour des injections de petites quantités. Elle se distingue par son design ergonomique et sa maniabilité simplifiée, permettant un dosage réglable en continu et précis. Même pour des quantités infimes, elle garantit une grande précision de dosage. Sa canule métallique est anti-usure, et le panier en plastique haute résistance offre une protection contre les coups et les chocs. Le remplacement des flacons de médicaments est simple et rapide, et la HSW ECO-MATIC® se distingue par un rapport qualité/prix exceptionnel, alliant performance et coût abordable.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pistolets"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719403571/Products/HSW_ECO-MATIC_xosj4o.webp",
        "category": "Injection",
        "target": "Usages divers",
        "title": "HSW ECO-MATIC®",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719403572/Products/HSW_ECO-MATIC_1_uvahux.webp",
        "subtitle": "Pistolet HSW ECO-MATIC® avec tube plongeur",
        "description": "HSW ECO-MATIC® avec tube plongeur est une seringue automatique en plastique premium conçue pour offrir une durabilité et une performance exceptionnelle. Fabriquée avec un cylindre en plastique haute résistance et une canule métallique anti-usure, cette seringue garantit une longue durée de vie même en usage intensif. Elle se distingue par son réglage de dosage précis et en continu, permettant une grande exactitude même pour des quantités infimes. Son design ergonomique facilite son maniement, offrant une utilisation simple et efficace. Livrée avec un tube plongeur, la HSW ECO-MATIC® est compatible avec le kit de capuchons de prélèvement et d'aération (réf. 31397), permettant une adaptation facile et rapide à divers besoins médicaux.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pistolets"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719404399/Products/Pistolet_drogueur_tttllj.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Pistolet drogueur",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719404399/Products/Pistolet_drogueur1_ulrpj3.webp",
        "subtitle": "Pistolet drogueur avec une capacité de 30 ml.",
        "description": "Le pistolet drogueur de 30 ml est idéal pour vermifuger les moutons et les bovins, offrant fiabilité et précision maximales grâce à ses pièces en acier inoxydable. Conçu pour une administration efficace des médicaments, il est équipé de valves spéciales qui évitent les obstructions lors de l'administration de liquides denses, garantissant une performance optimale et sans interruption.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "pistolets"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719405629/Products/nasofle_fdee8p.webp",
        "category": "Sondes",
        "target": "Équidés",
        "title": "NASOFLEX",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719405630/Products/nasoflex1_uje83d.webp",
        "subtitle": "Sondes naso-œsophagiennes en PVC transparent pour chevaux.",
        "description": "Nasoflex sont des sondes naso-œsophagiennes en PVC transparent pour chevaux se distinguent par leur embout arrondi ouvert équipé de deux œillets latéraux et une extrémité évasée facilitant l'utilisation avec une pompe ou un entonnoir. Elles offrent une bonne flexibilité tant en été qu'en hiver, sont atraumatiques et résistantes à la déformation, assurant une introduction aisée et un nettoyage simplifié.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719406518/Products/ESOFLEX_zgbdfm.webp",
        "category": "Sondes",
        "target": "Bovins",
        "title": "ESOFLEX",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719406519/Products/ESOFLEX1_nztfli.webp",
        "subtitle": "Sondes œsophagiennes en métal, gainées de plastique rouge, pour bovins et veaux.",
        "description": "Les sondes œsophagiennes ESOFLEX sont spécialement conçues en métal et gainées de plastique rouge pour une utilisation chez les bovins et les veaux. Elles sont essentielles pour intervenir en cas de météorisation, permettant l'évacuation des gaz avant l'utilisation d'un trocart. ",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719407700/Products/Anti-t%C3%A9t%C3%A9e_m%C3%A9tallique_fecbo7.webp",
        "category": "contention",
        "target": "veaux",
        "title": "Anti-tétée métallique",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719407701/Products/Anti-t%C3%A9t%C3%A9e_m%C3%A9tallique1_mwtixw.webp",
        "subtitle": "Anneaux antitêteurs en métal.",
        "description": "Les anneaux anti-têtée en métal sont utilisés pour empêcher les bovins, notamment les veaux et jeunes animaux, de têter leur mère ou d'autres bovins. Faciles à poser et à retirer à l'aide d'une pince dédiée (disponible séparément), ces anneaux favorisent une séparation prolongée entre la mère et le veau, encourageant ainsi une transition vers une alimentation solide. Ils préviennent également le comportement de succion indésirable, comme boire l'urine ou sucer le nombril d'autres animaux, tout en assurant le confort grâce à leurs protections pour le nez intégrées.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "contention elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719409599/Products/Anti-t%C3%A9t%C3%A9e_plastique_dapdsh.webp",
        "category": "contention",
        "target": "Bovins",
        "title": "Anti-tétée plastique",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719409599/Products/Anti-t%C3%A9t%C3%A9e_plastique1_u0q2es.webp",
        "subtitle": "Anneau anti-tétée en plastique pour bovins",
        "description": "L'anneau anti-têtée en plastique pour bovins est conçu pour être léger et doté de bouts arrondis afin de minimiser l'inconfort pour l'animal. Il est équipé d'une vis d'ajustement avec écrou papillon, facilitant son installation aux naseaux. Cet anneau empêche efficacement les vaches de têter d'autres vaches, contribuant ainsi à une gestion plus saine et efficace du troupeau.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "contention elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719410283/Products/Pince_pose_anneaux_g9qpnf.webp",
        "category": "Divers",
        "target": "Ovins",
        "title": "Pince pose anneaux",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719410282/Products/Pince_pose_anneaux1_o9pfcr.webp",
        "subtitle": "Pince pose anneaux de gomme",
        "description": "La pince pour pose d'anneaux de gomme est dotée d'une ouverture très large pour une installation aisée, avec une grande démultiplication pour un usage efficace. Fabriquée en acier nickelé forgé, cette pince est extrêmement résistante et représente le haut de gamme dans sa catégorie.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719412092/Products/Anneau_de_gomme_udf6b9.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Anneau de gomme",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719412092/Products/Anneau_de_gomme1_sekvfb.webp",
        "subtitle": "Anneau de gomme antiseptiques",
        "description": "Les anneaux de gomme antiseptiques sont spécialement conçus pour la castration et la caudectomie des veaux et des agneaux. Fabriqués avec des matériaux de haute qualité, ces anneaux garantissent une performance optimale. Ils sont adaptés pour une utilisation sur des agneaux ou des chevreaux âgés de moins de trois semaines, l'utilisation en dehors de cette période n'étant pas recommandée. La castration peut être effectuée quelques heures après la naissance de l'animal, l'efficacité étant optimale lorsque l'animal est jeune. Les anneaux ELASTRATOR sont fabriqués selon une méthode spécifique (gomme roulée) pour assurer leur efficacité.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719499125/Products/Anneau_taureau_slxjag.webp",
        "category": "contention",
        "target": "Taureaux",
        "title": "Anneau taureau 80",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719499126/Products/Anneau_taureau1_szj1sf.webp",
        "subtitle": "ANNEAU TAUREAU EN LAITON DIAMÈTRE 80 MM",
        "description": "Les anneaux pour taureaux en laiton, de diamètre interne 80 mm, se posent sans pince grâce à leur affûtage auto-perçant. Leur conception à ouverture plane des branches permet une installation facile et précise.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "contention elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719501879/Products/Anneau_taureau_50_ffymqp.webp",
        "category": "contention",
        "target": "Taureaux",
        "title": "Anneau taureau 50",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719501879/Products/Anneau_taureaux_50_kn682b.webp",
        "subtitle": "ANNEAU TAUREAU EN ACIER NICKELÉ VIS PAPILLON 50 MM",
        "description": "Les anneaux pour taureaux en acier nickelé avec vis papillon, d'un diamètre interne de 50 mm, se posent sans pince grâce à leur affûtage auto-perçant et leur ouverture plane des branches. Ces anneaux sont livrés avec une vis auto-cassante, garantissant une installation sûre et efficace.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "contention elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719560064/Products/Pince_mouchette_%C3%A0_coulant_kujvhc.webp",
        "category": "contention",
        "target": "Bovins",
        "title": "Pince mouchette à coulant",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719560064/Products/Pince_mouchette_%C3%A0_coulant1_ho8zkm.webp",
        "subtitle": "Pince de contention nasale",
        "description": "La pince mouchette à coulant, d'une longueur de 19 cm, est fabriquée en acier forgé nickelé. Les deux boules assurent une prise parfaite dans les naseaux des bovins. Les branches recourbées en demi-cercle s'appliquent sur la cloison nasale, permettant ainsi de contenir les animaux pour des opérations mineures ou des examens.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "contention elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719561147/Products/Pince_mouchette_%C3%A0_ressort_ar4jyc.webp",
        "category": "contention",
        "target": "Bovins",
        "title": "Pince mouchette à ressort",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719561147/Products/Pince_mouchette_%C3%A0_ressort1_iqjm21.webp",
        "subtitle": "PINCE MOUCHETTE À RESSORT SPIRALE",
        "description": "Cette pince mouchette de contention, équipée d'un ressort de serrage, permet une prise et une relâche rapide. Très robuste, elle est conçue pour une manipulation efficace des bovins. Avec une longueur de 17 cm, elle offre une solution fiable pour les opérations nécessitant une contention nasale rapide et sécurisée.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "contention elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719562096/Products/Pince_mouchette_%C3%A0_chaine_qmgpgf.webp",
        "category": "contention",
        "target": "Bovins",
        "title": "Pince mouchette à chaine",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719562097/Products/Pince_mouchette_%C3%A0_chaine1_bct6r0.webp",
        "subtitle": "Pince de contention à chaîne",
        "description": "Cette pince mouchette à chaîne est très robuste et est livrée avec une chaîne de maintien. Conçue pour une prise plus forte, elle ne comporte pas de crochet de blocage, ce qui minimise les risques de blessure pendant la manipulation.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "contention elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719564989/Products/Aiguillon_%C3%A9lectrique_t8bnnj.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Aiguillon électrique",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719564989/Products/Aiguillon_%C3%A9lectrique1_sp2u7t.webp",
        "subtitle": "Aiguillon électrique pour bovin",
        "description": "Aiguillon électrique avec consommation d'énergie réduite, offrant des performances exceptionnelles même avec de grandes amplitudes thermiques et sur des animaux mouillés. Il est protégé contre les projections d'eau (IP 45) et lavable, avec un effet 'ronfleur' pour un impact psychologique. Équipé d'un commutateur marche/arrêt pour éviter toute utilisation involontaire, il dispose d'une rallonge polycarbonate ultra-robuste de 71 cm. La batterie a une longue durée de vie grâce à une faible consommation d'énergie. L'électronique est protégée de la saleté, de la poussière, des vapeurs corrosives et des projections d'eau. L'aiguillon émet un avertissement sonore lors de l'activation et est protégé contre les déclenchements involontaires grâce à l'interrupteur marche/arrêt. La longueur totale de l'aiguillon est de 98 cm.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "contention elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719566595/Products/Serre_jarret_htyvzq.webp",
        "category": "contention",
        "target": "Bovins",
        "title": "Serre jarret",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719566593/Products/Serre_jarret1_xggwmv.webp",
        "subtitle": "Serre jarret pour bovins",
        "description": "Le serre-jarret pour bovins empêche les mouvements en se fixant au tendon, évitant ainsi les coups de pied lors du parage des pieds. Il bloque le jarret de la vache pendant la traite en se posant directement sur le jarret de l'animal et fonctionne par pincement du tendon. Ce dispositif est très efficace, avec une finition très robuste, et offre une sécurité accrue pour les intervenants et soignants.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "contention elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719567626/Products/Boucles_UKAL_FLEX_y8nzzo.webp",
        "category": "identification",
        "target": "Bovins",
        "title": "Boucles UKAL FLEX",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719567625/Products/Boucles_UKAL_FLEX1_oyg6uh.webp",
        "subtitle": "Boucles de marquage ukal flex",
        "description": "Les boucles de marquage Ukal Flex permettent une pose rapide, facile et sûre grâce à leur pointe de coupe chirurgicale unique, qui réduit les risques d'infection et favorise la cicatrisation. Disponibles en coloris jaune et mesurant 71 mm x 63 mm, elles sont livrées en boîte de 20 couples et peuvent être marquées à l'aide d'un stylo marqueur.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "identification elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719568308/Products/marqueur_noir_kg7ouu.webp",
        "category": "identification",
        "target": "Marquage",
        "title": "Marqueur noir",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719568308/Products/marqueur_noir1_dbfenz.webp",
        "subtitle": "marqueur noir pointe ronde",
        "description": "Le marqueur noir à pointe ronde est indélébile, idéal pour le marquage des colliers ovins, des plaques de cou, des bracelets et des boucles de marquage pour toutes les espèces. Il résiste au contact avec les matières organiques, les bases et les acides. ",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "identification elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719568796/Products/Boucles_TIP_TAG_vsxgtg.webp",
        "category": "identification",
        "target": "Petits ruminants",
        "title": "Boucles TIP TAG",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719568799/Products/Boucles_TIP_TAG1_nkok11.webp",
        "subtitle": "Boucles TIP TAG ovin",
        "description": "Les boucles TIP TAG pour ovins sont en plastique semi-rigide et composées de deux parties, mâle et femelle. Elles sont numérotées sur deux côtés, avec des dimensions de 35 x 10 mm. Vendues par paquet de 100.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "identification elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719569876/Products/Pince_TIP_TAG_nvzfsc.webp",
        "category": "identification",
        "target": "Petits ruminants",
        "title": "Pince TIP TAG",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719569876/Products/Pince_TIP_TAG1_mqs4u9.webp",
        "subtitle": "Pince pose boucle ovin ",
        "description": "La pince pose-boucle pour ovins est spécialement conçue pour les boucles TIP TAG et convient également à la plupart des autres boucles ovines disponibles sur le marché. Elle est ergonomique, robuste et facile à utiliser, garantissant une application rapide et sûre.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "identification elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719571530/Products/Pince_pour_Pose_de_Boucle_Bovins_bq49tj.webp",
        "category": "identification",
        "target": "Bovins",
        "title": "Pince à boucles bovins",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719571530/Products/Pince_pour_Pose_de_Boucle_Bovins1_rlhhzr.webp",
        "subtitle": "Pince pour Pose de Boucle Bovins",
        "description": "La pince pour pose de boucle bovins est spécialement conçue pour l'application de boucles d'oreille sur les bovins. Elle se distingue par sa facilité d'utilisation, sa sécurité renforcée grâce à un ressort pour l'ouverture, et sa robustesse, assurant une manipulation efficace et durable.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "identification elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719579038/Products/Crayons_marqueurs_hphcuv.webp",
        "category": "identification",
        "target": "Usages divers",
        "title": "Crayons marqueurs",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719579038/Products/Crayons_marqueurs1_wnblna.webp",
        "subtitle": "Crayons marqueurs raidex",
        "description": "Les crayons marqueurs RAIDEX sont fabriqués à partir de cires spéciales et d'huile de paraffine, offrant une qualité d'écriture supérieure sur le pelage des animaux. Ils sont résistants à la température, possèdent un fort pouvoir colorant et une haute brillance. Ces crayons, dont les composants sont sans danger pour la santé humaine et animale, sont principalement utilisés pour le marquage de courte durée des bovins et des ovins. Le marquage reste visible sur la croupe des animaux pendant près de quatre semaines.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "identification elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719579977/Products/COMBIVET_fojja1.webp",
        "category": "Protection",
        "target": "Usages divers",
        "title": "COMBIVET",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719579977/Products/COMBIVET1_guwsfo.webp",
        "subtitle": "Combinaison en polypropylène non tissé, avec capuche, pour visite et conduite d'élevage.",
        "description": "Combinaison en polypropylène non tissé avec capuche, idéales pour les visites et la conduite d'élevage. Fabriquée en polypropylène non tissé de 45 g/m², elle offre une toile résistante capable de supporter plusieurs lavages à 40°C. Elle est équipée de deux poches pantalon et d'une poche poitrine, d'une fermeture éclair, ainsi que d'élastiques à la taille, aux poignets et aux chevilles. De couleur bleue marine, ce combinaison protège des odeurs et est imperméable dans des conditions normales d'utilisation",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "protection elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719580833/Products/Blouse_Jetable_kqv9su.webp",
        "category": "Protection",
        "target": "Usages divers",
        "title": "Blouse Jetable",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719580833/Products/Blouse_Jetable1_hdlpsa.webp",
        "subtitle": "Blouse Jetable Blanche avec Fermeture Pression",
        "description": "Conçue avec des boutons pression, cette blouse robuste et non-pelucheuse assure une hygiène optimale. En non-tissé, elle offre une fermeture à pression pour une utilisation rapide et pratique. Couramment utilisée par les médecins, vétérinaires, et professionnels des métiers médicaux et paramédicaux, elle est également très prisée dans les ateliers, l'industrie agroalimentaire, la restauration et les collectivités.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "protection elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719581841/Products/title_Blouse_de_v%C3%AAlage_dzsk9f.webp",
        "category": "Protection",
        "target": "Usages divers",
        "title": "Blouse de vêlage",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719581840/Products/title_Blouse_de_v%C3%AAlage1_wo19tc.webp",
        "subtitle": "Blouse de vêlage à manches large",
        "description": "La blouse de vêlage avec manches est idéale pour les éleveurs lors de la mise à bas des animaux ainsi que pour divers soins vétérinaires. Utilisable également dans les industries agroalimentaires, elle est fabriquée à 100% en vinyle sur support jersey polyester, offrant une grande résistance aux produits d'entretien courants. Les manches longues assurent une protection optimale pour toutes vos tâches. Équipée de tabliers avec œillets et rondelles en inox, elle se ferme à l'arrière par un crochet plastique détectable et un élastique tressé polyester, avec un serrage au poignet par élastique polyester. La blouse est durable et se nettoie facilement grâce à son revêtement lisse.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "protection elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719584633/Products/TABLIER_BLANC1_pcwg7t.webp",
        "category": "protection",
        "target": "Usages divers",
        "title": "Tablier blanc",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719584633/Products/TABLIER_BLANC_tkk0dl.webp",
        "subtitle": "Tablier de laiterie blanc",
        "description": "Le tablier de laiterie blanc est recommandé pour les éleveurs laitiers dans leur laboratoire de transformation du lait à la ferme et leur salle de traite. Idéal pour les opérations de nettoyage et de plonge dans le domaine agricole, il est également adapté pour l'hôtellerie et la restauration. Fabriqué à 100% en vinyle, il est très résistant aux produits d'entretien courants. Il dispose d'une sangle de fixation au cou avec un crochet en inox et en plastique, ainsi que des œillets et rondelles en inox. Les boucles de réglage en polypropylène alimentaire et le crochet plastique détectable avec élastique tressé polyester assurent un ajustement sécurisé. Ce tablier, durable et facile à nettoyer grâce à son revêtement lisse, offre une protection fiable et pratique pour diverses applications.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "protection elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719585855/Products/ECOGAN_fzwzic.webp",
        "category": "protection",
        "target": "Usages divers",
        "title": "Gant de fouille ECOGAN",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719585854/Products/ECOGAN1_xzn4zx.webp",
        "subtitle": "Gant d'exploration à usage unique en polyéthylène",
        "description": " Gant d'exploration à usage unique en polyéthylène de 25 µm. De couleur verte et sans lien, il offre une sensibilité tactile standard. Ce gant ambidextre de 90 cm, avec cinq doigts, est fabriqué en polyéthylène haute densité lisse, garantissant un bon toucher et une excellente protection.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "protection elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719586790/Products/Polysem_pelyh5.webp",
        "category": "protection",
        "target": "Usages divers",
        "title": "Gant de fouille Polysem",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719586790/Products/Polysem1_wckyzn.webp",
        "subtitle": "Gant d'insémination - Polysem",
        "description": "Les gants de protection à usage vétérinaire Polysem sont idéals pour les délivrances et l'insémination. Ils offrent une excellente résistance à la déchirure et, une fois étirés, adhèrent parfaitement à la main et au bras pour une manipulation précise. Longueur : 92 cm. Livrés en boîte de 100 gants.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "protection elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719651280/Products/D%C3%A9cong%C3%A9lateur_a4iepm.webp",
        "category": "reproduction",
        "target": "Bovins",
        "title": "Décongélateur",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719651279/Products/D%C3%A9cong%C3%A9lateur1_oke7ck.webp",
        "subtitle": "Décongélateur de semence Minitube",
        "description": "Le décongélateur de semence Minitube est un appareil polyvalent et facile à transporter, idéal pour une utilisation sur le terrain. Il permet de régler la température et une décongélation rapide avec un affichage numérique de la température réelle. Les paillettes congelées se décongèlent en environ 30 secondes dans la chambre de décongélation remplie d'eau. Le support de paillettes comporte trois compartiments, permettant de décongeler jusqu'à 10 paillettes à la fois (0,5 ml ou 0,25 ml). Le couvercle fermé s'ajuste parfaitement, sans risque de fuite. Le design mince permet de le transporter facilement et de le placer dans le porte-gobelet de la voiture. Il est facile à manipuler et suffisamment robuste pour durer de nombreuses années. Le décongélateur peut être utilisé dans la voiture (12 V/24 V) ou branché à une prise murale (110/230 V).",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "reproduction elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719652850/Products/Bol_de_traite_ekt0cf.png",
        "category": "Traite",
        "target": "Bovins",
        "title": "Bol de traite",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719652849/Products/Bol_de_traite1_fpnwmj.png",
        "subtitle": "Bol de traite en plastique avec tamis conique.",
        "description": "Le bol de traite pour mammite est conçu pour la détection des mammites chez les vaches laitières. Son tamis noir met en évidence les caillots ou filaments présents dans le lait, permettant d'observer la consistance du lait (grumeaux, morceaux, etc.) dès les premiers jets de la traite.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "traite"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719653453/Products/Goblet_de_trempage_evhom6.webp",
        "category": "Traite",
        "target": "Usages divers",
        "title": "Goblet de trempage",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719653454/Products/Goblet_de_trempage1_arkxtx.webp",
        "subtitle": "Goblet de trempage anti-retour",
        "description": "Le goblet de trempage est équipé d'un dispositif anti-retour qui empêche le produit usé de retourner dans le réservoir, garantissant que le produit propre et efficace est appliqué sur les trayons de chaque vache. La lèvre anti-projections, spécialement conçue avec une chambre à débordement, limite le gaspillage en récupérant le produit excédentaire. La compression facile du récipient en plastique souple permet une application aisée. Avec une capacité de coupelle de 30 ml, ce goblet est idéal pour le pré- et le post-trempage. Il dispose également d'un crochet de suspension pratique pour la ceinture.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "traite"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719653929/Products/Trayonotome_wkrbwm.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "COUTEAU TRAYONOTOME",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719653929/Products/Trayonotome1_zdk97i.webp",
        "subtitle": "COUTEAU TRAYONOTOME INOX 14 CM",
        "description": "Le couteau trayonotome en acier inoxydable est conçu pour l'incision des trayons. Doté d'une double lame, il garantit une précision maximale. Sa longueur est de 14 cm et son diamètre de 3,6 mm, assurant une manipulation facile et une efficacité optimale.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "traite"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719654533/Products/Sonde_trayeuse_dh9o4k.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Sonde trayeuse plastique ",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719654532/Products/Sonde_trayeuse1_zw6gph.webp",
        "subtitle": "Canule mammaire pour vaches",
        "description": "Canules mammaires en plastique pour le bétail, utilisées à des fins vétérinaires. Disponibles en deux longueurs différentes, elles permettent de maintenir le canal mammaire ouvert pour faciliter la cicatrisation en cas d'infection ou de traitements divers. Chaque boîte contient 10 unités, avec embout imprégné de vaseline lubrifiante pour une insertion facile et confortable.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "traite"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719655045/Products/SONDES_TRAYEUSES_c1ugl4.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Sondes trayeuse inox",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719655046/Products/SONDES_TRAYEUSES1_npklrt.webp",
        "subtitle": "SONDE TRAYEUSE INOX 63 MM",
        "description": "Sonde trayeuse en inox avec embout Luer Lock, conçue pour faciliter le passage des solutions grâce à deux ouvertures latérales. La sonde en inox assure durabilité et hygiène, tandis que la base en laiton chromé offre une robustesse supplémentaire. Dimensions : longueur de 63 mm et diamètre de 2 mm.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "traite"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719655657/Products/Papier_test_mammite_hh0gri.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Papier test mammite",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719655658/Products/Papier_test_mammite1_se5bej.webp",
        "subtitle": "PAPIER BROMOTHYMOL POUR MAMMITES",
        "description": "Le papier bromothymol pour mammites est un outil diagnostique essentiel pour détecter l'acidification du lait, causée par une augmentation du nombre de cellules, indiquant la présence de mammite. Chaque test permet une analyse rapide de la réaction du lait, facilitant la comparaison des quatre quartiers de la mamelle pour un contrôle complet. Livré en sachets contenant 25 tests.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "traite"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719656864/Products/V%C3%AAleuse_dgbabs.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Vêleuse",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719656863/Products/V%C3%AAleuse1_mdmnrz.webp",
        "subtitle": "Tractionneuse",
        "description": "La vêleuse en acier inoxydable offre une puissance de traction élevée de 300 kg, permettant une grande liberté d'action ainsi qu'une force de traction alternée des deux pattes, idéale pour assister efficacement lors de la mise bas.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "vêlage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719657520/Products/Crochet_de_v%C3%AAlage_krjocj.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Crochet de vêlage double",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719657520/Products/Crochet_de_v%C3%AAlage1_f56d46.webp",
        "subtitle": "Crochet de vêlage articulé, 2 dents",
        "description": "Le crochet articulé à deux dents pour vêlage est fabriqué en acier inoxydable de haute qualité, indispensable dans tout cabinet vétérinaire. Cet outil chirurgical est utilisé pour retirer un fœtus mort afin de sauver la femelle. Les dents pointues du crochet pénètrent profondément dans les tissus pour faciliter cette procédure délicate.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "vêlage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719819781/Products/Crochet_de_v%C3%AAlage_pointu_sfn84x.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Crochet de vêlage pointu",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719819781/Products/Crochet_de_v%C3%AAlage_pointu1_vms9rv.webp",
        "subtitle": "Crochet oculaire pointu en obstétrique",
        "description": "Le crochet de vêlage pointu est un outil essentiel en obstétrique vétérinaire, particulièrement pour les interventions de vêlage et d'accouchement. Fabriqué en acier inoxydable, il dispose d'un œil émoussé, conçu pour une utilisation efficace et sécurisée lors des interventions sur les veaux. Ce crochet à œil, robuste et durable, est un instrument indispensable dans les fournitures vétérinaires pour assurer des accouchements réussis.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "vêlage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719824570/Products/Scie_fil_qooy3k.webp",
        "category": "écornage",
        "target": "Usages divers",
        "title": "Scie fil",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719824570/Products/Scie_fil1_k8d2a9.webp",
        "subtitle": "Fil tressé en acier",
        "description": "La scie fil est un outil spécialement conçu pour une utilisation rapide et facile dans le domaine de l'élevage. Fabriquée en fil tressé en acier spécial, elle est robuste et durable. Elle s'utilise avec des poignées pour un maniement optimal.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "écornage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719825142/Products/Poign%C3%A9e_scie_fil_awvpgk.webp",
        "category": "écornage",
        "target": "Usages divers",
        "title": "Poignée scie fil",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719825142/Products/Poign%C3%A9e_scie_fil1_aduoyr.webp",
        "subtitle": "Paire de poignées scie-fil",
        "description": "Les poignées pour scie fil, conçues pour être utilisées avec une scie fil, sont essentielles dans les interventions sur les animaux d'élevage. Avant toute utilisation, il est crucial d'anesthésier localement et de tranquilliser l'animal, puis de placer un garrot à la base des cornes pour bloquer le flux sanguin et prévenir l'hémorragie. Fixez les embouts du fil aux poignées, puis entamez doucement la corne pour éviter tout dérapage. Si le sectionnement est proche de la base (moins de 4 cm), appliquez un tampon de pansement imbibé de collodion pour éviter l'infection. Au-delà de 4 cm, la corne restante ne présente généralement pas de risques d'infection. Il est essentiel de ne pas intervenir sur les vaches et génisses dans les deux mois précédant le vêlage, d'éviter les interventions en été pour prévenir les infections dues aux insectes, et de ne pas intervenir en cas de gelée ou de vent très froid pour éviter les sinusites post-coupe. Ces poignées assurent une utilisation précise et sécurisée de la scie fil.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "écornage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719826705/Products/Seau_%C3%A0_veau_nlvxlp.webp",
        "category": "Allaitement",
        "target": "Veaux",
        "title": "Seau à veau 8L",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719826705/Products/Seau_%C3%A0_veau1_vqze2v.webp",
        "subtitle": "seau à veau plastique 8L avec tétine",
        "description": "Le seau à veaux en plastique de 8 litres, équipé d'une tétine, est conçu avec un dos plat et une forme convexe pour éviter le gaspillage et permettre un écoulement quasi complet du lait. Le seau Tetiblue offre une stabilité remarquable grâce à son dos plat, et son absence d'angles droits le rend très facile à nettoyer. Sa sécurité est optimale grâce à son plastique alimentaire et à son clapet avec bille de verre. Il est complet avec tétine, clapet et anse, et possède une jauge de chaque côté. Ce seau est résistant aux acides, non toxique, et facile d'entretien.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "allaitement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719830101/Products/T%C3%A9tine_pour_seau_%C3%A0_veau_rudil3.webp",
        "category": "Allaitement",
        "target": "Veaux",
        "title": "Tétine pour seau à veau",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719830101/Products/T%C3%A9tine_pour_seau_%C3%A0_veau1_zcpwmt.webp",
        "subtitle": "TÉTINE POUR SEAU À VEAU TETIBLUE 8 LITRES",
        "description": "Les tétines pour seau à veau Tetiblue 8 litres sont atoxiques, fabriquées en caoutchouc naturel et exemptes de nitrosamines. Conçues pour un usage alimentaire, elles répondent aux conditions requises pour l'alimentation des veaux. De couleur sable, leurs dimensions sont de 35 x 100 mm.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "allaitement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719830856/Products/Biberon_%C3%A0_veau_twnwnp.webp",
        "category": "Allaitement",
        "target": "Veaux",
        "title": "Biberon à veau 2L",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719830857/Products/Biberon_%C3%A0_veau1_iy50rs.webp",
        "subtitle": "BIBERON À VEAU EN PLASTIQUE 2 LITRES",
        "description": "Le biberon à veau en plastique alimentaire de 2 litres est conçu avec une poignée pour une prise en main facile. Il possède une graduation tous les 250 mL. Fabriqué en plastique de première qualité, il est épaissi, sûr, sain, et durable pour une utilisation à long terme.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "allaitement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719831593/Products/Socle_flottant_cmyl7x.webp",
        "category": "Allaitement",
        "target": "Veaux",
        "title": "Socle flottant",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719831593/Products/Socle_flottant1_b3yqd3.webp",
        "subtitle": "Socle flottant",
        "description": "Le socle flottant est conçu pour maintenir la tétine tournée vers le haut et flotter efficacement. Sa double bague de serrage empêche la pénétration du lait, garantissant étanchéité et propreté. Pratique et facile à démonter, il est également simple à nettoyer grâce à sa forme spéciale qui permet au veau de consommer tout le lait contenu dans le seau.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "allaitement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719836702/Products/TETINE_AGNEAU_l40x3o.webp",
        "category": "Allaitement",
        "target": "Agneaux",
        "title": "TETINE AGNEAU",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719836701/Products/TETINE_AGNEAU1_tlklvw.webp",
        "subtitle": "TETINE AGNEAU Multi Biberon",
        "description": "La Tétine Agneau Multi Biberon est conçue pour une alimentation optimale des agneaux. Réalisée en caoutchouc naturel de haute qualité, elle est atoxique et libre de nitrosamines, garantissant une sécurité alimentaire maximale. Sa forme ergonomique facilite l'aspiration et simule la tétée naturelle, assurant ainsi un confort optimal pour les agneaux. Compatible avec plusieurs types de biberons, cette tétine est durable et facile à nettoyer, offrant une solution pratique et hygiénique pour l'élevage des jeunes ovins.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "allaitement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719837536/Products/T%C3%89TINE_AGNEAU_oqnsog.webp",
        "category": "Allaitement",
        "target": "Agneaux",
        "title": "TÉTINE AGNEAU (BOUTEILLE)",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719837536/Products/T%C3%89TINE_AGNEAU1_dbflo0.webp",
        "subtitle": "Tétines en latex pour bouteille",
        "description": "Les tétines agneau en latex pour bouteille, percées de deux trous, sont extrêmement souples et fabriquées en caoutchouc naturel de haute qualité. Conçues pour offrir une expérience de tétée naturelle et confortable, ces tétines sont idéales pour nourrir les agneaux de manière efficace et hygiénique.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "allaitement"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719840549/Products/pate-a-ecorner_lctext.webp",
        "category": "écornage",
        "target": "Bovins",
        "title": "PÂTE ÉCORNAGE",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719840548/Products/pate-a-ecorner1_pg7bxf.webp",
        "subtitle": "PÂTE NETHORN POUR ÉCORNAGE",
        "description": "La pâte Nethorn pour écornage est spécialement conçue pour l'écornage des veaux de moins de trois semaines. Ce produit corrosif doit être utilisé avec précaution. Pour l'emploi, régler la molette de la seringue pour sortir la dose utile, puis déposer la pâte sur la surface totale du cornillon en le grattant légèrement avec la pointe de la seringue pour une meilleure application. Il est important de maintenir le veau à l'écart des autres animaux pendant 3 à 4 heures pour éviter les risques de léchage et les brûlures des muqueuses chez les autres animaux. Utilisable pour des veaux de 8 à 20 jours. Ne pas maintenir les veaux en lots lors de l'écornage.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "écornage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719841575/Products/Crayon_pour_%C3%A9cornage_xemfmo.webp",
        "category": "écornage",
        "target": "Bovins",
        "title": "Crayon pour écornage",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719841575/Products/Crayon_pour_%C3%A9cornage1_j77kgq.webp",
        "subtitle": "Bâtonnet d'écornage",
        "description": "Le crayon pour écornage est conçu pour l'écornage des veaux jusqu'à un mois. Pour l'utiliser, frottez intensément le cornillon pendant 1 à 2 minutes. Ce crayon, contenant du potassium caustique, est corrosif et doit être manipulé avec précaution.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "écornage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719842268/Products/ECORNEUR_%C3%89LECTRIQUE_cylgyt.webp",
        "category": "écornage",
        "target": "Bovins",
        "title": "ECORNEUR ÉLECTRIQUE",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719842268/Products/ECORNEUR_%C3%89LECTRIQUE1_lu8hc1.webp",
        "subtitle": "ECORNEUR ÉLECTRIQUE AVEC TRANSFORMATEUR 24 V",
        "description": "L'écorneur électrique avec transformateur 24 V est spécialement conçu pour l'écornage des veaux. Cet appareil atteint une température de 600°C, garantissant une efficacité optimale. Il est livré avec une barre d'écornage et un transformateur de sécurité 24 V. Le support pour fer est intégré, offrant une praticité accrue. L'écorneur dispose d'un câble de 4 mètres de long, permettant une grande liberté de mouvement. Avec une puissance de 250 W, il est fourni avec un embout de 17 mm.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "écornage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719843653/Products/%C3%89masculateur_ublfex.webp",
        "category": "Castration",
        "target": "Bovins",
        "title": "Émasculateur",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719843653/Products/%C3%89masculateur1_jzkrso.webp",
        "subtitle": "Pince castratrice",
        "description": "Un émasculateur est un outil chirurgical utilisé principalement en médecine vétérinaire pour la castration des animaux mâles. Il combine deux actions en une : couper et écraser les cordons spermatiques. La coupe permet de retirer les testicules, tandis que l'écrasement aide à prévenir les saignements en scellant les vaisseaux sanguins. Cet instrument est essentiel pour assurer une procédure rapide, propre et sûre, minimisant ainsi les complications post-opératoires.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719844727/Products/%C3%89masculateur_%C3%A0_3_broches_wtqiqm.webp",
        "category": "Castration",
        "target": "Chevaux",
        "title": "Émasculateur à 3 broches",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719844727/Products/%C3%89masculateur_%C3%A0_3_broches1_ovvksz.webp",
        "subtitle": "Pince à Castrer de Sand et de Reimer's pour Chevaux",
        "description": "Les pinces à castrer de Sand et de Reimer's sont des instruments vétérinaires de haute précision en acier inoxydable, conçus spécifiquement pour la castration des chevaux. Elles possèdent des mors lisses et sont entièrement démontables, facilitant ainsi leur nettoyage et entretien. Avec une double émasculation et une crémaillère de fermeture rallongée, ces pinces assurent une procédure sécurisée et efficace. Les bras de coupe indépendants et affûtables garantissent une utilisation durable et fiable.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719911289/Products/Testeur_d_Onglons_engaax.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "TESTEUR D'ONGLONS",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719911289/Products/Testeur_d_Onglons1_zsckfl.webp",
        "subtitle": "Gabarit de mesure pour sabot",
        "description": "Le Testeur d'Onglons est un outil essentiel pour les éleveurs et les vétérinaires, garantissant la forme idéale de l'onglon de manière rapide et sécurisée. Il permet de contrôler précisément l'angle du sabot entre la base et la partie avant supérieure, qui doit être compris entre 45° et 50°. Conçu avec un angle fixe de 50°, ce testeur assure des résultats fiables et uniformes, facilitant ainsi l'entretien optimal des onglons.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "parage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719911953/Products/R%C3%89NETTE_ANNULAIRE_l7xpi9.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "RÉNETTE ANNULAIRE",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719911916/Products/R%C3%89NETTE_ANNULAIRE1_ekrqrz.webp",
        "subtitle": "Couteau de parage annulaire",
        "description": "La rénette annulaire est un outil de haute qualité conçu pour le nettoyage et le parage de la sole des sabots. Elle dispose d'une lame en acier traité, offrant une durabilité exceptionnelle et une coupe précise. Son manche en bois assure une prise en main confortable et stable. La finition soignée de cette rénette annulaire en fait un choix parfait pour les professionnels souhaitant un outil performant et esthétique.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "parage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719913055/Products/R%C3%89NETTE_OVIN_qsfljp.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "RÉNETTE OVIN",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719913056/Products/R%C3%89NETTE_OVIN1_qcrdaf.webp",
        "subtitle": "Rénette à onglons pour ovins",
        "description": "Cette rénette ovin est dotée d'une lame en acier inox spécial avec une teneur élevée en chrome, offrant une résistance exceptionnelle à l'usure et une longue durée de vie. Sa surface polie et son affûtage optimal garantissent un outil parfait pour une utilisation intensive en milieu animalier. La poignée ergonomique en bois dur, résistante à l'eau, permet une transmission optimale de la force appliquée par l'utilisateur sur la lame, facilitant une coupe améliorée et précise. Idéale pour le nettoyage et le parage des sabots, cette rénette en acier spécial de haute qualité assure un travail précis et aisé.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "parage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719914689/Products/Cisaille_%C3%A0_onglons_f0cjlk.webp",
        "category": "Divers",
        "target": "Ovins",
        "title": "Cisaille à onglons",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719914688/Products/Cisaille_%C3%A0_onglons1_t34dgu.webp",
        "subtitle": "Cisaille à onglons pour mouton",
        "description": "Cisaille à onglons professionnelle pour ovins et caprins, idéale pour les moutons et les chèvres. Les lames très effilées et à tranchant exceptionnel, mesurant 6 cm de longueur, sont interchangeables pour une utilisation prolongée. Le manche en aluminium, à la fois léger et résistant, assure une bonne prise en main grâce à sa poignée épaisse en aluminium.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "parage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719915886/Products/COUPE_ONGLONS_BOVINS_xcuvuu.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "COUPE ONGLONS BOVINS",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719915886/Products/COUPE_ONGLONS_BOVINS1_guale4.webp",
        "subtitle": "Cisailles à onglons pour bovins",
        "description": "Le coupe-onglons pour bovins est doté d'une tête ronde à mâchoires croisées, permettant une attaque latérale efficace de la corne. Fabriqué en acier nickelé, cet outil garantit une durabilité et une résistance accrues pour un usage intensif en élevage.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "parage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719919177/Products/R%C3%A2pe_sabots_aqv2ya.webp",
        "category": "Divers",
        "target": "Équidés",
        "title": "Râpe sabots",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719919175/Products/R%C3%A2pe_sabots1_uimbk1.webp",
        "subtitle": "Râpe sabots cheval avec manche",
        "description": "La râpe à sabots professionnelle pour cheval, un outil essentiel en maréchalerie, est équipée de deux faces distinctes : une pour le limage et une pour le râpage. Son manche en caoutchouc antidérapant assure une prise en main sécurisée. Cette râpe est utilisée pour égaliser la corne du pied du cheval et pour façonner le contour du sabot. Elle mesure environ 35 cm de longueur et 4,5 cm de largeur.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "parage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719922689/Products/Disque_parage_dx18ns.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Disque parage",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719922689/Products/Disque_parage1_upntr3.webp",
        "subtitle": "Disque abrasif sabot",
        "description": "Le disque abrasif pour sabot est conçu pour être utilisé avec une petite meuleuse. Sa surface ondulée facilite la réduction et le nettoyage des sabots, offrant ainsi une solution efficace pour l'entretien des pieds des animaux.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "parage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719923509/Products/Pierre_%C3%A0_aiguiser_y0jrak.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Pierre à aiguiser",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719923509/Products/Pierre_%C3%A0_aiguiser1_i7vmlg.webp",
        "subtitle": "PIERRE À AFFÛTER POUR RÉNETTES",
        "description": "La pierre à affûter pour rénettes est essentielle pour l'affûtage précis des rénettes, des cisailles à onglons et des couteaux de bergers. Son grain très fin assure un affûtage minutieux des outils de parage, garantissant une performance optimale lors de leur utilisation.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "parage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719924546/Products/DISQUE_DL_SOFT_l8msox.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "DISQUE DL SOFT",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719924547/Products/DISQUE_DL_SOFT1_yeletj.webp",
        "subtitle": "Disque De Parage DL Soft ",
        "description": "Le disque DL Soft Ø 10 cm pour couper les onglons a été développé en étroite collaboration avec des pareurs d'onglons professionnels. Fabriqué en aluminium, il offre une robustesse légère et une durée de vie exceptionnelle grâce à ses 7 lames en tungstène préréglées en usine. Ce disque assure une coupe franche dégageant de gros copeaux, sans échauffement du pied ni production de poussière ou de fumées. Chaque jeu de lame peut traiter plus de 400 bovins et les lames réversibles peuvent être changées individuellement, garantissant une utilisation prolongée. Idéal pour une utilisation avec une petite meuleuse d'angle à faible vitesse d'environ 750 watts, avec une performance optimale à environ 10 000 tours par minute.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "parage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719925611/Products/TONDEUSE_Heiniger_Xtra_gwkbfy.webp",
        "category": "Tonte",
        "target": "Ovins",
        "title": "TONDEUSE Heiniger Xtra",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719925612/Products/TONDEUSE_Heiniger_Xtra1_wpn4ix.webp",
        "subtitle": "TONDEUSE ÉLECTRIQUE HEINIGER XTRA 320 W TÊTE LARGE OVIN",
        "description": "La tondeuse électrique Heiniger Xtra 320 W pour ovins est une machine super puissante, solide et robuste, équipée d'un système de coupe breveté exclusif. Elle réduit considérablement les vibrations grâce aux mouvements équilibrés des peignes, tout en optimisant l'énergie du moteur. Avec une puissance de 320 watts et environ 2400 cycles de va-et-vient par minute, cette tondeuse est idéale pour les ovins et les caprins. Livrée en coffret avec une tête de tonte large et un jeu de peignes 13 et 4 dents, elle assure une pénétration aisée de la toison.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "tonte"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719927473/Products/TONDEUSE_HEINIGER_XPERT_u5txyj.webp",
        "category": "Tonte",
        "target": "Ovins",
        "title": "TONDEUSE HEINIGER XPERT",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719927473/Products/TONDEUSE_HEINIGER_XPERT1_eeubja.webp",
        "subtitle": "TONDEUSE HEINIGER XPERT 2 VITESSES POUR MOUTON",
        "description": "La tondeuse Xpert Heiniger à 2 vitesses pour mouton représente un concentré de puissance et de fiabilité, fabriquée en Suisse. Avec jusqu'à 2800 oscillations par minute à la vitesse supérieure et un moteur puissant, elle permet une tonte rapide et efficace des moutons sans effort. Légère et maniable, cette tondeuse combine force et technologie de pointe. Son design innovant assure une liaison stable et unique entre la tête de coupe et le corps renforcé en fibre de verre, réduisant ainsi les vibrations pendant la tonte. Que vous soyez professionnel ou amateur, la tondeuse Xpert offre une expérience de tonte exceptionnelle pour moutons, chèvres et camélidés. Certifiée CE/Electrosuisse, chaque tondeuse est livrée dans un coffret complet incluant le mode d'emploi, les lames, un tournevis, un pinceau de nettoyage et de l'huile. Un jeu de peigne Ovina Premium est également inclus et préinstallé pour une utilisation immédiate.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "tonte"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719927957/Products/FORCE_%C3%80_TONDRE_rzbwdw.webp",
        "category": "Tonte",
        "target": "Ovins",
        "title": "FORCE À TONDRE",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719927958/Products/FORCE_%C3%80_TONDRE1_ctdkzp.webp",
        "subtitle": "FORCE À TONDRE PROFESSIONNELLE 34 CM",
        "description": "La force à tondre professionnelle de 34 cm est l'outil idéal pour la tonte des moutons. Conçue pour offrir une performance optimale, cette tondeuse se distingue par sa qualité de fabrication et ses lames de 16,5 cm, assurant une tonte facile et efficace. Robuste et facile d'utilisation, elle garantit des résultats précis et rapides lors de chaque session de tonte.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "tonte"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719928933/Products/TROCART_OVIN_cpn3tf.webp",
        "category": "Météorisation",
        "target": "Ovins",
        "title": "TROCART OVIN",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719928934/Products/TROCART_OVIN1_mcwukx.webp",
        "subtitle": "TROCARD OVINS ROND, 6MM",
        "description": "Le trocart rond de 6 mm pour ovins est conçu pour le percement de la panse en cas de météorisation, offrant une solution efficace lorsque la sonde n'a pas donné satisfaction. Avec un diamètre de 6 mm et une longueur de 12 cm, cet outil est spécifiquement adapté aux ovins pour garantir une intervention précise et sécurisée.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719929778/Products/TROCARD_BOVIN_ngbsp1.webp",
        "category": "Météorisation",
        "target": "Bovins",
        "title": "TROCARD BOVIN",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719929779/Products/TROCARD_BOVIN1_irwket.webp",
        "subtitle": "Trocart ruminal",
        "description": "Le trocart pour bovins, avec un diamètre de 10 mm et une longueur de 15 cm, est conçu pour le percement de la panse en cas de météorisation. Cet outil s'utilise lorsque la sonde œsophagienne n'a pas donné satisfaction, offrant une solution fiable et précise pour les interventions vétérinaires sur les bovins.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719991737/Products/AIMANT_EN_CAGE_obtlk8.webp",
        "category": "Divers",
        "target": "Bovins",
        "title": "Aimant cagé",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719991739/Products/AIMANT_EN_CAGE1_v6yn8h.webp",
        "subtitle": "AIMANT EN CAGE",
        "description": "L'aimant cagé est conçu pour accumuler plus efficacement les particules métalliques, les alignant longitudinalement grâce à sa conception ergonomique. Il utilise un système d'aimants en ferrite active offrant une force de traction et d'adhérence élevées, garantissant des résultats thérapeutiques optimaux. Cet aimant gastrique est destiné à la thérapie et à la prophylaxie de la maladie des corps étrangers chez les bovins. Sa force magnétique puissante permet d'extraire les corps étrangers ferreux fraîchement enfoncés de la paroi réticulo-gastrique, assurant une protection efficace contre les complications liées aux corps étrangers.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719992214/Products/GUIDE_POUSSOIR_AIMANTS_oxujfy.webp",
        "category": "Divers",
        "target": "Bovins",
        "title": "GUIDE AIMANTS",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719992213/Products/GUIDE_POUSSOIR_AIMANTS1_rm6z5p.webp",
        "subtitle": "GUIDE POUSSOIR POUR AIMANTS",
        "description": "Ce guide poussoir en acier nickelé facilite la mise en place de l'aimant dans l'estomac de l'animal. Il retient l'aimant de manière sécurisée pendant toute l'opération, garantissant une insertion précise et efficace.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719995668/Products/AIGUILLE_CADAVERIQUE_pqwp0t.webp",
        "category": "CHIRURGIE",
        "target": "Suture",
        "title": "AIGUILLE INCURVÉE EN S",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719995668/Products/AIGUILLE_CADAVERIQUE1_ysquvg.webp",
        "subtitle": "Aiguille à coudre incurvée en S",
        "description": "L'aiguille à coudre incurvée en S est une aiguille de suture en acier inoxydable. Elle est courbée à 3/8 de cercle, mesurant 132 mm de longueur avec une courbe de 104 mm. Elle est dotée d'une pointe ronde, idéale pour les sutures vétérinaires.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "aiguilles de suture"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719997992/Products/Huile_de_paraffine_kct13y.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "HUILE DE PARAFFINE",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719997992/Products/Huile_de_paraffine1_nrnyij.webp",
        "subtitle": "Huile minérale paraffinée",
        "description": "L'huile de paraffine est un laxatif efficace, idéal pour traiter la constipation et les symptômes de coliques. Utilisée couramment dans le domaine vétérinaire, elle aide à lubrifier le tractus intestinal, facilitant ainsi le passage des matières fécales. Notre huile de paraffine est vendue en récipient d'un litre, garantissant une quantité suffisante pour plusieurs utilisations. Facile à administrer et sécuritaire, c'est un indispensable dans la trousse de soins de tout éleveur ou vétérinaire.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Produits chimiques"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719998518/Products/Iode_qoaecn.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "IODE",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719998518/Products/Iode1_murwpr.webp",
        "subtitle": "Iode en Récipient d'un Litre",
        "description": "Notre solution d'iode, vendue en récipient d'un litre, est idéale pour une désinfection efficace et polyvalente. Utilisée pour désinfecter la peau, les pieds et les sabots des animaux, elle est également parfaite pour assainir les locaux. Sa formule puissante assure une protection optimale contre les infections, faisant de cette solution un indispensable pour maintenir une hygiène impeccable.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Produits chimiques"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719999296/Products/MONOPROPYL%C3%88NE_GLYCOL_bdwnnp.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "MPG",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1719999296/Products/MONOPROPYL%C3%88NE_GLYCOL1_ngrfck.webp",
        "subtitle": "MONOPROPYLÈNE GLYCOL en Récipient d'un Litre",
        "description": "Le monopropylène glycol est un précurseur du glucose essentiel pour combler le déficit énergétique chez les animaux en début de lactation, période où le risque d'acétonémie (ou cétose) est le plus élevé. Ce produit vétérinaire de haute qualité soutient efficacement la santé et la performance de vos animaux en assurant un apport énergétique crucial.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Produits chimiques"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720001138/Products/Bleu_de_M%C3%A9thyl%C3%A8ne_proyh6.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "BLEU DE MÉTHYLÈNE",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720001138/Products/Bleu_de_M%C3%A9thyl%C3%A8ne1_q8lcnm.webp",
        "subtitle": "Bleu de Méthylène en Récipient d'un Litre",
        "description": "Le bleu de méthylène, ou chlorure de méthylthioninium, est un composé hétérocyclique à trois noyaux dérivé de la phénothiazine. Utilisé à la fois comme médicament et colorant, ce produit se distingue par ses propriétés rédox uniques. Idéal pour une variété d'applications médicales et de coloration, ce récipient d'un litre de bleu de méthylène est un ajout essentiel à votre arsenal de produits.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Produits chimiques"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720001952/Products/Bicarbonate_de_sodium_r7syyp.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "BICARBONATE DE SODIUM",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720001952/Products/Bicarbonate_de_sodium1_gvmt6s.webp",
        "subtitle": "BICARBONATE DE SODIUM en Récipient d'un kg",
        "description": "Le bicarbonate de sodium est un traitement efficace recommandé pour l'acidose métabolique chez les bovins, les chevaux et les moutons. Adapté selon les facteurs de cause, ce produit est essentiel pour rétablir l'équilibre acido-basique chez les animaux, favorisant leur bien-être et leur récupération rapide. Un incontournable dans le traitement vétérinaire des troubles métaboliques.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Produits chimiques"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720003293/Products/CARBONATE_DE_CALCIUM_wzqp6m.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "CARBONATE DE CALCIUM",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720003293/Products/CARBONATE_DE_CALCIUM1_bdwh3j.webp",
        "subtitle": "CARBONATE DE CALCIUM en Récipient d'un kg",
        "description": "Le carbonate de calcium est essentiel pour le métabolisme et l'ossification des animaux, offrant un apport concentré de calcium pour l'alimentation minérale de votre élevage. Indispensable pour toutes les espèces animales, il favorise une croissance saine et un développement optimal des os, garantissant la santé et la productivité de votre troupeau laitier.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Produits chimiques"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720010301/Products/Sulfate_de_magn%C3%A9sium_hs11cv.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "SULFATE DE MAGNÉSIUM",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720010301/Products/Sulfate_de_magn%C3%A9sium1_cqkbfj.webp",
        "subtitle": "Sulfate de magnésium en Récipient d'un kg",
        "description": "Le sulfate de magnésium est un activateur enzymatique aux multiples effets bénéfiques pour la santé animale. Il ralentit l'activité des cellules myocardiques, détend les cellules musculaires lisses des vaisseaux sanguins et amplifie l'efficacité des médicaments de relaxation musculaire. En réduisant l'hyperactivité neuronale, il est utilisé pour traiter certaines crises comme celles causées par l'éclampsie. Il prévient également les accouchements prématurés en inhibant les contractions utérines et est employé pour prévenir les irrégularités du rythme cardiaque, notamment les torsades de pointes, surtout en phase initiale de l'infarctus du myocarde.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "Produits chimiques"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720013828/Products/PISTOLET_D_INS%C3%89MINATION_JUMENTS_y7utos.webp",
        "category": "Insémination",
        "target": "Juments",
        "title": "PISTOLET D'INSÉMINATION JUMENTS",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720013828/Products/PISTOLET_D_INS%C3%89MINATION_JUMENTS1_s5xasl.webp",
        "subtitle": "Stylet flexible utilisé avec la pipette d'insémination universelle 57 cm et les paillettes de 0,5 ml",
        "description": "Ce pistolet d'insémination est conçu pour l'insémination intra-utérine profonde ou transcervicale des juments. Doté d'un stylet flexible, il est compatible avec une pipette universelle et des paillettes de 0,5 ml. Les deux boutons permettent de retirer facilement les paillettes vides et de recharger la pipette pour une utilisation rapide et efficace. Fabriqué en acier inoxydable, ce pistolet assure robustesse et durabilité pour un usage vétérinaire professionnel.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "reproduction elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720014924/Products/Pistolet_d_ins%C3%A9mination_Flexia_xssyuy.webp",
        "category": "Insémination",
        "target": "Usages divers",
        "title": "Pistolet d'insémination Flexia",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720014924/Products/Pistolet_d_ins%C3%A9mination_Flexia1_jmxjqm.webp",
        "subtitle": "pistolet d'insémination Flexia AI",
        "description": "Le pistolet d'insémination Flexia AI est adapté à une utilisation avec des gaines fendues et non fendues. Il peut accueillir des paillettes de 0,25 ml (mini) et de 0,50 ml (maxi) sans nécessiter d'anneaux de verrouillage. Ce pistolet de très haute qualité est fabriqué par IMV en France.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "reproduction elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720016122/Products/QuickLock_Classic_zzhdsw.webp",
        "category": "Insémination",
        "target": "Bovins",
        "title": "QuickLock Classic",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720016122/Products/QuickLock_Classic1_bpnwdz.webp",
        "subtitle": "pistolet d'insémination bovine QuickLock Classic",
        "description": "Pistolet polyvalent pour tous types de paillettes et de gaines, fendues ou non fendues. Fixation et libération faciles de la gaine par simple pression sur un bouton. Design unique pour un alignement sécurisé et centré des paillettes - aucune perte de semence. Composé uniquement de pièces en acier inoxydable et stérilisables. Fixation et libération de la gaine avec une seule main. Aucune pièce détachée - le cran de sécurité empêche le piston de glisser. Identification grâce à des stylets de différentes couleurs. Libération séparée des paillettes pour le contrôle des informations après l'insémination.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "reproduction elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720016582/Products/QUICKLOCK_2000_gl3ui3.webp",
        "category": "Insémination",
        "target": "Bovins",
        "title": "QuickLock 2000",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720016582/Products/QUICKLOCK_2000_1_qjy6cd.webp",
        "subtitle": "QuickLock 2000, pistolet d'insémination bovine",
        "description": "Pistolet polyvalent pour tous types de paillettes et de gaines, fendues ou non fendues. Design ergonomique. Seul 1 cm de la longueur de la gaine est nécessaire pour la fixation. Design unique pour un alignement sécurisé et centré des paillettes - aucune perte de semence. Composé uniquement de pièces en acier inoxydable et stérilisables. Fixation et libération de la gaine avec une seule main. Aucune pièce détachée - le cran de sécurité empêche le piston de glisser. Identification grâce à des stylets de différentes couleurs. Libération séparée des paillettes pour le contrôle des informations après l'insémination.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "reproduction elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720018812/Products/QuickLock_Ergo_aykhef.webp",
        "category": "Insémination",
        "target": "Bovins",
        "title": "QuickLock Ergo",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720018812/Products/QuickLock_Ergo1_smpeds.webp",
        "subtitle": "QuickLock Ergo, pistolet d'insémination bovine",
        "description": "Pistolet polyvalent pour tous types de paillettes et de gaines, fendues ou non fendues. Idéal pour les vaches plus âgées grâce à une longueur utilisable accrue. Doté de la plus petite poignée ergonomique disponible. Le pistolet le plus facile à nettoyer. Design unique pour un alignement sécurisé et centré des paillettes - aucune perte de semence. Composé uniquement de pièces en acier inoxydable et stérilisables. Fixation et libération de la gaine avec une seule main. Aucune pièce détachée - le cran de sécurité empêche le piston de glisser. Identification grâce à des stylets de différentes couleurs. Libération séparée des paillettes pour le contrôle des informations après l'insémination.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "reproduction elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720080404/Products/Pistolet_d_ins%C3%A9mination_profonde_hsasyz.webp",
        "category": "Insémination",
        "target": "Bovins",
        "title": "Pistolet d'insémination profonde",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720080404/Products/Pistolet_d_ins%C3%A9mination_profonde1_heuimf.webp",
        "subtitle": "Pistolet pour insémination intra-utérine profonde et transfert d'embryons bovins",
        "description": "Ce pistolet est conçu pour l'insémination intra-utérine profonde et le transfert d'embryons chez les bovins, utilisant des paillettes de 0,25 ml et des gaines IUI profondes. Il comprend une longue gaine flexible et un mandrin pour l'IA ou le placement d'embryons profondément dans la corne utérine. L'ensemble se compose d'un stylet d'introduction, d'un stylet flexible AI/ET, d'un support de doigt et de deux anneaux de fixation, permettant un dépôt précis et sécurisé des embryons.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "reproduction elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720081715/Products/Pistolet_d_ins%C3%A9mination_universel_IMV_wuszkf.webp",
        "category": "Insémination",
        "target": "Bovins",
        "title": "Pistolet d'insémination universel IMV",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720081715/Products/Pistolet_d_ins%C3%A9mination_universel_IMV1_z2ur7m.webp",
        "subtitle": "Pistolet d'insémination artificielle universel 0,25 ml à 0,50 ml pour bovins",
        "description": "Ce pistolet manuel est conçu pour l'injection de semence et le transfert d'embryons chez les bovins. Il est compatible avec des paillettes de 0,25 ml à 0,50 ml, offrant une polyvalence maximale pour toutes vos opérations d'insémination artificielle et de transfert d'embryons. Fabriqué avec des matériaux de haute qualité pour garantir la durabilité et la précision, ce pistolet facilite les procédures de reproduction avec une efficacité optimale.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "reproduction elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720083660/Products/Gaine_d_ins%C3%A9mination_%C3%A9quines_gfunnv.webp",
        "category": "Insémination",
        "target": "Juments",
        "title": "Gaine d'insémination équines",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720083659/Products/Gaine_d_ins%C3%A9mination_%C3%A9quines1_hvxgcz.webp",
        "subtitle": "Sondes d'insémination équines non stériles - Minitube",
        "description": "Les sondes d'insémination artificielles non stériles de Minitube sont très flexibles et équipées de deux embouts de couleur bleue. L'embout arrondi et lisse permet une introduction en douceur, tandis que la gaine flexible facilite le maniement. L'embout moulé avec précision, doté d'un cône interne pour paillette de 0,5 ml, permet le dépôt direct de 100 % de la semence dans l'utérus. Grâce au système de rechargement, la même sonde peut être rechargée avec des paillettes consécutives in situ lorsqu'elle est utilisée avec le pistolet d'insémination.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "reproduction elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720084575/Products/Gaine_d_ins%C3%A9mination_KRUUSE_ztzney.webp",
        "category": "Insémination",
        "target": "Juments",
        "title": "Gaine d'insémination KRUUSE",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720084575/Products/Gaine_d_ins%C3%A9mination_KRUUSE1_u3d1pu.webp",
        "subtitle": "Sondes d'insémination équines non stériles - Kruuse - 25 pièces",
        "description": "Les sondes d'insémination artificielle non stériles Kruuse mesurent 70 cm et sont équipées d'un embout en caoutchouc pour la fixation de la seringue, garantissant une préparation facile et rapide avant l'insémination. Leur extrémité arrondie et lisse permet une introduction en douceur, assurant ainsi le confort et la sécurité de la jument. Vendu en paquet de 25 pièces, cet outil est idéal pour une utilisation efficace et fiable.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "reproduction elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720087476/Products/R%C3%A9cipient_%C3%A0_azote_liquide_dbygpx.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Récipient à azote liquide",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720087475/Products/R%C3%A9cipient_%C3%A0_azote_liquide1_zlh4wo.webp",
        "subtitle": "Réservoir d'azote liquide en alliage d'aluminium",
        "description": "Ce réservoir en alliage d'aluminium est conçu pour le stockage et le transport d'azote liquide. Non pressurisé, il se caractérise par une construction en aluminium et alliage léger, dotée d'un col en matériau composite. Cette conception combine faible consommation, légèreté et robustesse, tout en garantissant un faible taux d'évaporation grâce à son col étroit en fibres de verre. Ce récipient sans pression offre une solution extrêmement efficace pour le stockage de l'azote liquide.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "divers elevage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720089062/Products/Lac_de_v%C3%AAlage_clqgkr.webp",
        "category": "Divers",
        "target": "Usages divers",
        "title": "Lac de vêlage",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720089062/Products/Lac_de_v%C3%AAlage1_rfrthn.webp",
        "subtitle": "Lac de vêlage en polyamide avec anneau métal",
        "description": "Conçu pour une mise bas en douceur, ce lac de vêlage allie solidité et douceur grâce à son anneau de 50 mm en métal et son matériau en polyamide. Il minimise le risque de blessures pour le veau et le poulain. Résistant à l'usure et équipé de deux passants, il est non tranchant, offrant ainsi une solution sûre et durable pour les vétérinaires et éleveurs.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "vêlage"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720094424/Products/Hemovet_hcgrbr.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Chien",
        "title": "Hemovet",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720094425/Products/Hemovet1_bkwpbm.webp",
        "subtitle": "Complément alimentaire pour chien",
        "description": "Hemovet est un complément alimentaire innovant spécialement conçu pour soutenir efficacement le traitement de l'anémie chez les chiens. Formulé avec une combinaison synergique de fer hémique, chélate de cuivre, vitamines B6 et B12, acide folique et vitamine C, Hemovet stimule la production de globules rouges essentiels tout en améliorant la santé globale de l'animal. Idéal pour les chiens anémiés, Hemovet favorise leur récupération en réduisant les signes tels que la pâleur des muqueuses, l'essoufflement et la fatigue, résultant souvent d'un manque de nutriments cruciaux ou de conditions médicales sous-jacentes.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720097386/Products/Hepatiale_Forte_Advanced_gm1eqr.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Chat/chien",
        "title": "Hepatiale Forte Advanced",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720097385/Products/Hepatiale_Forte_Advanced1_y2j13m.webp",
        "subtitle": "Complément alimentaire pour chien et chat.",
        "description": "Hepatiale Forte Advanced de VetExpert est un complément alimentaire de pointe conçu pour soutenir efficacement la santé hépatique des chats et chiens. Formulé avec une combinaison synergique d'ingrédients premium tels que SAMe, silymarine, phospholipides, ornithine et zinc, ce produit offre un soutien complet à la fonction hépatique en favorisant la régénération cellulaire, en protégeant contre les dommages oxydatifs, en soutenant la structure cellulaire et en aidant à éliminer les toxines. Essentiel pour maintenir des fonctions vitales comme le métabolisme, la détoxification et l'immunité, Hepatiale Forte Advanced est votre allié pour assurer le bien-être optimal de votre animal.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires canine"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720095671/Products/Senio_Top_yqejcd.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "chien",
        "title": "Senio Top",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720095671/Products/Senio_Top1_dfxqiz.webp",
        "subtitle": "Complément alimentaire pour chien.",
        "description": "Senio Top de VetExpert, un complément alimentaire innovant spécialement conçu pour répondre aux besoins des chiens seniors. Formulé avec une combinaison précise de 7 ingrédients synergiques, Senio Top aide à atténuer les effets du vieillissement en améliorant la mobilité, l'énergie et le bien-être général de votre chien. En soutenant la santé globale des chiens âgés, ce produit contribue à maintenir leur vitalité et leur qualité de vie.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires canine"
    }
    ,
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720096269/Products/Qalmil_u32nd1.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Chat/chien",
        "title": "Qalmil",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720096269/Products/Qalmil_1_uynv1o.webp",
        "subtitle": "Complément alimentaire pour chien et chat.",
        "description": "Qalmil de VetExpert, le complément alimentaire de choix pour apaiser et calmer efficacement les chiens et chats confrontés au stress et à l'anxiété. Formulé pour moduler les réactions comportementales inadaptées et favoriser une adaptation harmonieuse aux changements environnementaux, Qalmil offre une solution précieuse pour maintenir la sérénité de vos vos animaux. En agissant pour prévenir les états anxieux et soutenir leur bien-être émotionnel, Qalmil est essentiel pour les propriétaires soucieux du confort et de l'équilibre émotionnel de leurs animaux.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires canine"
    }
    ,
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720171648/Products/FERTIMAX_vps77o.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Bovins",
        "title": "FERTIMAX",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720171648/Products/FERTIMAX1_okhpjv.webp",
        "subtitle": "Additif alimentaire pour ameliorer la fertilité des genisses et des vaches",
        "description": "Additif alimentaire conçu pour améliorer la fertilité des génisses et des vaches, FERTIMAX aide à obtenir un meilleur taux de réussite à la première insémination et à éviter le retour en chaleur après l'insémination. Il contribue également à préparer les vaches et les génisses à l'œstrus, optimisant ainsi leur fertilité et augmentant les chances de conception.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires betail"
    }
    ,
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720172172/Products/FEED_MILK_sww8nj.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Bovins",
        "title": "FEED MILK",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720172172/Products/FEED_MILK1_dr2p6v.webp",
        "subtitle": "Additif alimentaire pour les vaches laitieres.",
        "description": "Additif alimentaire destiné aux vaches laitières, FEED MILK augmente la production laitière en améliorant la qualité du lait. Il aide à prévenir les problèmes de mammites et fournit les vitamines et oligo-éléments nécessaires pour une lactation optimale.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires betail"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720172827/Products/CALVING_FEED_sb2vyr.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Bovins",
        "title": "CALVING FEED",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720172827/Products/CALVING_FEED1_vjbhn6.webp",
        "subtitle": "Additif alimentaire pour les vaches taries",
        "description": "Additif alimentaire pour les vaches taries, CALVING FEED améliore les conditions de vêlage, prévient la rétention placentaire et assure une bonne santé des vaches et des génisses au moment du vêlage, permettant ainsi une lactation optimale.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires betail"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720184232/Products/CALF_GROWTH1_uasali.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Bovins",
        "title": "CALF GROWTH",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720184232/Products/CALF_GROWTH_ufgx1a.webp",
        "subtitle": "Additif alimentaire pour veaux en engraissement",
        "description": "Additif alimentaire pour veaux en engraissement, CALF GROWTH améliore la croissance des bovins de 125 kg jusqu'à l'abattage en augmentant le gain moyen quotidien (GMQ). Il optimise la transformation des aliments en viande, permettant d'obtenir un meilleur poids vif à l'abattage avec un rendement maximal de viande.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires betail"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720184829/Products/LAMB_GROWTH_bnlakd.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Ovins",
        "title": "LAMB GROWTH",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720184828/Products/LAMB_GROWTH1_ulwjlj.webp",
        "subtitle": "Additif alimentaire pour agneaux en engraissement",
        "description": "Additif alimentaire pour agneaux en engraissement, LAMB GROWTH améliore la performance des agneaux de 12 kg de poids vif jusqu'à l'abattage en augmentant le gain moyen quotidien (GMQ) et l'indice de consommation. Il maximise le rendement de viande à l'abattage.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires betail"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720185372/Products/SHEEP_oh84yo.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Ovins",
        "title": "SHEEP",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720185373/Products/SHEEP1_egwwtc.webp",
        "subtitle": "ADDITIF ALIMENTAIRE POUR BREBIS",
        "description": "Additif alimentaire pour brebis, SHEEP améliore la santé, la fertilité et l'entretien des brebis. Il compense les carences en vitamines et en oligo-éléments des rations, et renforce l'immunité des brebis.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires betail"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720186319/Products/RAM_wdtpb7.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Ovins",
        "title": "RAM",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720186320/Products/RAM1_bdqqam.webp",
        "subtitle": "Additif alimentaire pour béliers",
        "description": "Additif alimentaire pour béliers, RAM améliore la santé, la fertilité et l'entretien des béliers. Il équilibre les rations en vitamines et en oligo-éléments, et renforce l'immunité des béliers.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires betail"
    },
    {
        "src": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720189331/Products/EQUIPOWER_uqtwmu.webp",
        "category": "COMP ALIMENTAIRE",
        "target": "Chevaux",
        "title": "EQUIPOWER",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "https://res.cloudinary.com/dgizp0ygl/image/upload/v1720189332/Products/EQUIPOWER1_ombhqc.webp",
        "subtitle": "Additif alimentaire pour ameliorer la performance des chevaux",
        "description": "Additif alimentaire pour améliorer la performance des chevaux. EQUIPOWER favorise la fécondité des poulinières, la croissance des jeunes chevaux, ainsi que la fertilité des étalons et des juments. Il maximise également les performances des chevaux de sport.",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires betail"
    },
    {
        "src": "",
        "category": "COMP ALIMENTAIRE",
        "target": "Ovins",
        "title": "",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "",
        "subtitle": "",
        "description": "",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "compléments alimentaires betail"
    },
    {
        "src": "",
        "category": "Insémination",
        "target": "Juments",
        "title": "",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "",
        "subtitle": "",
        "description": "",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "reproduction elevage"
    },
    {
        "src": "",
        "category": "Insémination",
        "target": "Juments",
        "title": "",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "",
        "subtitle": "",
        "description": "",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "reproduction elevage"
    },
    {
        "src": "",
        "category": "Insémination",
        "target": "Juments",
        "title": "",
        "promotion": false,
        "topSale": false,
        "newProduct": false,
        "srcSP": "",
        "subtitle": "",
        "description": "",
        "specification": "",
        "in_stock": true,
        "promotionOffer": "",
        "filter": "reproduction elevage"
    }
]

export const partners = [
    {
        src: genia,
        title: "Génia",
        description: "Génia, leader dans la fabrication de matériel pour les professionnels de la santé animale (vétérinaires, éleveurs, laboratoires).",
        href: "https://genia.fr/fr/",
        website: "www.genia.fr"
    },
    {
        src: imv,
        title: "imv-technologies",
        description: "Leader mondial des biotechnologies de reproduction animale, IMV Technologies fournit des solutions pour améliorer les troupeaux des éleveurs et centres d'insémination.",
        href: "https://www.imv-technologies.fr/",
        website: "www.imv-technologies.fr"
    },
    {
        src: spermex,
        title: "GGI-Spermex",
        description: "GGI-Spermex, la principale organisation d'exportation de Fleckvieh et Brown Swiss dans le monde entier.",
        href: "https://www.ggi-spermex.de/",
        website: "www.ggi-spermex.de"
    },
    {
        src: lactalis,
        title: "Lactalis",
        description: "Implantée au cœur des bassins laitiers, Lactalis perpétue les traditions laitières avec une vision à long terme.",
        href: "https://www.lactalis.com/",
        website: "www.lactalis.com"
    },
    {
        src: coopex,
        title: "Coopex",
        description: "Umotest, réunissant 8 coopératives d'insémination montbéliardes, innove depuis plus de 50 ans pour offrir une génétique performante et adaptée aux éleveurs.",
        href: "https://www.coopex.com/",
        website: "www.coopex.com"
    },
    {
        src: obione,
        title: "Obione",
        description: "Fidèle à son expertise, Obione offre des produits aux éleveurs, vétérinaires et entreprises du secteur agricole et agroalimentaire.",
        href: "https://www.obione.fr/",
        website: "www.obione.fr"
    },
    {
        src: synetics,
        title: "SYNETICS",
        description: "Leader européen de la génétique bovine et caprine, offre une génétique de pointe et des solutions innovantes aux éleveurs et vétérinaires.",
        href: "https://www.evolution-xy.fr/index/bovin/lait",
        website: "www.evolution-xy.fr"
    },
    {
        src: aberekin,
        title: "Aberekin",
        description: "Fondé en 1985 par des éleveurs, ABEREKIN teste chaque année plus de 50 jeunes taureaux races laitières et de races à viande.",
        href: "https://www.aberekin.com/inicio",
        website: "www.aberekin.com"
    }
]

export const spec = [
    {
        " Caractéristique":"GZW",
        "Valeur (Index)": "138",
        "Analyse": "Un GZW très élevé qui témoigne de performances globales exceptionnelles",
    },
    {
        " Caractéristique":"Index lait (MW)",
        "Valeur (Index)": "122",
        "Analyse": "Très Bon indice, montrant que les filles de Vassri produisent beaucoup plus de lait que la moyenne.",
    },
    {
        " Caractéristique":"Lait",
        "Valeur (Index)": "+1004 kg",
        "Analyse": "Augmentation significative de la production laitière par rapport à la moyenne.",
    },
    {
        " Caractéristique":"Protéines",
        "Valeur (Index)": "-0.08% (+29 kg)",
        "Analyse": "Légère diminution en pourcentage, mais augmentation notable en kg, favorable pour la production.",
    },
    {
        " Caractéristique":"Matières grasses",
        "Valeur (Index)": "-0.09 % (+34 kg)",
        "Analyse": "Augmentation notable en termes de quantité de matière grasse.",
    },
    {
        " Caractéristique":"Valeur bouchère",
        "Valeur (Index)": "101",
        "Analyse": "Qualité acceptable de la viande des veaux issus de ce taureau.",
    },
    {
        " Caractéristique":"FIT (Fonctionnalité)",
        "Valeur (Index)": "118",
        "Analyse": "Très bonne note, montrant de très bonnes caractéristiques fonctionnelles.",
    },
    {
        " Caractéristique":"Longévité",
        "Valeur (Index)": "117",
        "Analyse": "Les filles de ce taureau vivent plus longtemps que la moyenne.",
    },
    {
        " Caractéristique":"Santé mamelle",
        "Valeur (Index)": "108",
        "Analyse": "Excellente santé des mamelles.",
    },
    {
        " Caractéristique":"Facilité de naissance",
        "Valeur (Index)": "113",
        "Analyse": "Pas de problèmes particuliers pour la naissance des veaux.",
    },
    {
        " Caractéristique":"Facilité de vêlage",
        "Valeur (Index)": "98",
        "Analyse": "Note moyenne, réduisant les risques de complications lors du vêlage.",
    },
    {
        " Caractéristique":"Persistance",
        "Valeur (Index)": "111",
        "Analyse": "Excellente persistance de la production laitière tout au long de la lactation.",
    },
    {
        " Caractéristique":"Cellules somatiques",
        "Valeur (Index)": "110",
        "Analyse": "Bonne santé des mamelles avec peu d'infections.",
    },
    {
        " Caractéristique":"Fertilité maternelle",
        "Valeur (Index)": "111",
        "Analyse": "Très bonne fertilité des filles de ce taureau.",
    },
    {
        " Caractéristique":"Vitesse de traite",
        "Valeur (Index)": "99",
        "Analyse": "Vitesse de traite correcte.",
    },
    {
        " Caractéristique":"Comportement de traite",
        "Valeur (Index)": "106",
        "Analyse": "Bon comportement lors de la traite",
    },
    {
        " Caractéristique":"Santé des sabots",
        "Valeur (Index)": "100",
        "Analyse": "Bonne santé des sabots.",
    }
]

// filtres:
//- Canine: compléments alimentaires canine, pansement, contention canine, protection canine, sondes urinaires, prélèvements et examens, divers canine,

//- Elevage: contention elevage, identification elevage, protection elevage, reproduction elevage, traite, vêlage, allaitement, écornage, parage, tonte, divers elevage, compléments alimentaires betail

//- Chirurgie : Pinces, ciseaux, aiguilles de suture, divers chirurgie

//- Injection : seringues, aiguilles, pistolets, divers injection

//- Divers : Produits chimiques, Autres

//target: Usages divers,

//category : Injection,

// product image : 410*310 = 0.756